/* ============================================================
   NATTA Form — sav custom JS u jednom fajlu
   Redoslijed: global (money/events/cart-helperi/meni/akordioni)
   -> cart (drawer) -> sections (below-fold) -> product (PDP)
   -> collection (filteri). Svaki dio je samostalan IIFE sa
   guard-ovima — preskače ako njegovih elemenata nema na stranici.
   ============================================================ */


/* ===================== natta-global.js ===================== */
/* ============================================================
   NATTA Form — globalni JS (money, meni, badge, countdown,
   akordioni, free-ship helper)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var format = (window.NattaSettings && window.NattaSettings.moneyFormat) || 'KM {{amount_with_comma_separator}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0];
    var dec = parts[1];
    var withComma = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec;
    var withPeriod = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + dec;
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount\s*\}\}/g, withPeriod);
  }

  window.NattaMoney = { format: formatMoney };

  /* ---------- pub/sub ---------- */
  var subscribers = {};
  function publish(event, data) {
    (subscribers[event] || []).forEach(function (cb) { cb(data); });
  }
  function subscribe(event, cb) {
    (subscribers[event] = subscribers[event] || []).push(cb);
    return function () {
      subscribers[event] = subscribers[event].filter(function (c) { return c !== cb; });
    };
  }
  window.NattaEvents = { publish: publish, subscribe: subscribe };

  /* ---------- cart badge ---------- */
  subscribe('cart:change', function (cart) {
    document.querySelectorAll('[data-natta-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.dataset.count = cart.item_count;
      el.setAttribute('aria-hidden', cart.item_count === 0 ? 'true' : 'false');
    });
  });

  /* ---------- meni drawer (mobile) ----------
     Drawer nosi aria-modal="true", pa se od njega ocekuje da preuzme
     fokus dok je otvoren i da ga vrati na dugme kad se zatvori. Bez toga
     je tabulator nastavljao kroz stranicu IZA overlaya, a citac ekrana
     citao sadrzaj koji se ne vidi. Escape ga takodjer nije zatvarao —
     zajednicki handler nize pokriva korpu i modale, ali meni nije bio u
     njemu. */
  var menuLastFocus = null;

  function menuOpen(drawer, trigger) {
    menuLastFocus = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    var burger = document.querySelector('[data-natta-menu-open]');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    // Tri zamke, sve tri izmjerene u pregledniku:
    //   1. drawer je do klika `visibility: hidden`; stil se ne preradi u
    //      istom tiku, pa fokus u tom trenutku preglednik tiho odbije;
    //   2. prvi `[data-natta-menu-close]` je SCRIM — <div> sa
    //      `display: none` i 0x0, koji se ne moze fokusirati;
    //   3. `requestAnimationFrame` se NE izvrsava dok je dokument skriven
    //      (`visibilityState === 'hidden'`) — recimo kad se stranica
    //      otvori u pozadinskoj kartici. Zato ide i setTimeout, a posao
    //      se radi samo jednom.
    var focusDone = false;
    var giveFocus = function () {
      if (focusDone) return;
      // Prvi fokusabilan u drawer-u je LOGO — kupac koji odmah pritisne
      // Enter zavrsi na naslovnoj. Zato prvo dugme za zatvaranje, pa tek
      // onda prvi iscrtan element.
      var pick = null;
      var closeBtn = drawer.querySelector('button[data-natta-menu-close]');
      if (closeBtn && closeBtn.getClientRects().length) {
        pick = closeBtn;
      } else {
        var focusables = drawer.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
        for (var fi = 0; fi < focusables.length; fi++) {
          if (focusables[fi].getClientRects().length) { pick = focusables[fi]; break; }
        }
      }
      if (!pick) return;
      try { pick.focus(); } catch (err) {}
      if (document.activeElement === pick) focusDone = true;
    };
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () { window.requestAnimationFrame(giveFocus); });
    }
    setTimeout(giveFocus, 0);
  }

  function menuClose(drawer) {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    var burger = document.querySelector('[data-natta-menu-open]');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    var back = menuLastFocus || burger;
    menuLastFocus = null;
    if (back) { try { back.focus(); } catch (err) {} }
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-natta-menu-open]');
    var close = e.target.closest('[data-natta-menu-close]');
    var drawer = document.querySelector('[data-natta-menu-drawer]');
    if (!drawer) return;
    if (open) menuOpen(drawer, open);
    else if (close) menuClose(drawer);
  });

  /* ---------- quick add (kartica → size chips) ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-quickadd-toggle]');
    if (!toggle) return;
    var wrap = toggle.closest('[data-quickadd]');
    var sizes = wrap && wrap.querySelector('[data-quickadd-sizes]');
    if (!sizes) return;
    toggle.hidden = true;
    sizes.hidden = false;
  });

  /* ---------- akordioni ----------
     Markup: [data-natta-accordion] > item > button[data-acc-toggle][aria-expanded][aria-controls=ID]
     + div#ID (tijelo se nalazi preko aria-controls, ne preko data-atributa)
     Jedan otvoren istovremeno; "+" rotira 45° kroz CSS [aria-expanded]. */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-acc-toggle]');
    if (!toggle) return;
    var group = toggle.closest('[data-natta-accordion]');
    if (!group) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    group.querySelectorAll('[data-acc-toggle]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var b = document.getElementById(t.getAttribute('aria-controls'));
      if (b) {
        b.style.maxHeight = '0px';
        // Bez ovoga zatvoreni odgovor ostaje u tab redoslijedu i citac
        // ekrana ga procita, dok aria-expanded tvrdi da je zatvoren.
        b.setAttribute('inert', '');
        b.setAttribute('aria-hidden', 'true');
      }
    });
    if (!expanded) {
      toggle.setAttribute('aria-expanded', 'true');
      var body = document.getElementById(toggle.getAttribute('aria-controls'));
      if (body) {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.removeAttribute('inert');
        body.removeAttribute('aria-hidden');
      }
    }
  });

  // Bez ovoga su svi zatvoreni odgovori do prvog klika u tab redoslijedu
  // i citac ekrana ih cita, dok aria-expanded tvrdi da su zatvoreni.
  document.querySelectorAll('[data-acc-toggle]').forEach(function (t) {
    if (t.getAttribute('aria-expanded') === 'true') return;
    var b = document.getElementById(t.getAttribute('aria-controls'));
    if (b) { b.setAttribute('inert', ''); b.setAttribute('aria-hidden', 'true'); }
  });

  /* ---------- countdown (campaign) ----------
     [data-natta-countdown][data-end="YYYY-MM-DDTHH:MM"] — skriva se kad istekne. */
  function initCountdowns() {
    document.querySelectorAll('[data-natta-countdown]').forEach(function (el) {
      if (el.dataset.countdownInit) return;
      var end = new Date(el.dataset.end);
      if (isNaN(end.getTime())) { el.hidden = true; return; }
      el.dataset.countdownInit = '1';
      var hh = el.querySelector('[data-cd-h]');
      var mm = el.querySelector('[data-cd-m]');
      var ss = el.querySelector('[data-cd-s]');
      function tick() {
        var t = Math.floor((end - new Date()) / 1000);
        if (t <= 0) { el.hidden = true; clearInterval(id); return; }
        if (hh) hh.textContent = String(Math.floor(t / 3600)).padStart(2, '0');
        if (mm) mm.textContent = String(Math.floor((t % 3600) / 60)).padStart(2, '0');
        if (ss) ss.textContent = String(t % 60).padStart(2, '0');
      }
      var id = setInterval(tick, 1000);
      tick();
    });
  }
  document.addEventListener('DOMContentLoaded', initCountdowns);
  subscribe('dom:updated', initCountdowns);

  /* ---------- free-ship bar updater ---------- */
  window.NattaFreeShip = {
    update: function (root, currentCents) {
      root.querySelectorAll('[data-natta-freeship]').forEach(function (bar) {
        var threshold = parseInt(bar.dataset.threshold, 10) || 17000;  // isti fallback kao natta_free_ship_threshold (170 KM)
        var remaining = threshold - currentCents;
        var pct = Math.min(100, (currentCents / threshold) * 100);
        var fill = bar.querySelector('[data-freeship-fill]');
        var label = bar.querySelector('[data-freeship-label]');
        if (fill) fill.style.width = pct + '%';
        bar.classList.toggle('is-done', remaining <= 0);
        if (label) {
          label.innerHTML = remaining <= 0
            ? '<span class="n-freeship__check">✓</span> Ostvarena <strong>BESPLATNA dostava</strong>'
            : 'Još <strong class="n-freeship__amount">' + (window.NattaMoney && window.NattaMoney.format ? window.NattaMoney.format(remaining) : 'KM ' + (remaining / 100).toFixed(2).replace('.', ',')) + '</strong> do <strong>besplatne dostave</strong>';
        }
      });
    }
  };
})();

/* ===================== natta-cart.js ===================== */
/* ============================================================
   NATTA Form — cart drawer (Ajax Cart API + Section Rendering)
   Jedini izvor istine je Shopify cart; nakon svake mutacije
   re-renderujemo sekciju 'cart-drawer' i objavljujemo cart:change.
   ============================================================ */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';

  /* Zahtjevi se serijalizuju umjesto da se odbacuju. Raniji "busy" flag je
     tiho gutao klikove i vracao Promise.resolve(), pa je PDP prikazivao
     "Dodato u korpu" iako zahtjev nikad nije poslan. */
  function noop() {}
  var queue = Promise.resolve();
  function enqueue(task) {
    var run = queue.then(task, task);
    queue = run.then(noop, noop);
    return run;
  }

  /* Zeljena kolicina po liniji dok zahtjevi jos putuju — bez ovoga bi uzastopni
     klikovi citali zastarjeli data-qty iz DOM-a i svi slali istu kolicinu. */
  var pendingQty = {};
  var inflight = {};

  function drawer() {
    return document.querySelector('[data-natta-cart-drawer]');
  }

  // Fokus se nije vracao na dugme koje je otvorilo drawer — poslije
  // zatvaranja bi pao na <body> i Tab bi krenuo od vrha stranice.
  var lastFocused = null;

  function open() {
    lastFocused = document.activeElement;
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('n-no-scroll');
    var panel = d.querySelector('[data-natta-cart-panel]');
    if (panel) panel.focus({ preventScroll: true });
  }

  function close() {
    if (lastFocused && lastFocused.focus) {
      try { lastFocused.focus({ preventScroll: true }); } catch (e) {}
      lastFocused = null;
    }
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('n-no-scroll');
  }

  function renderSection(html) {
    var d = drawer();
    if (!d || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-natta-cart-content]');
    var target = d.querySelector('[data-natta-cart-content]');
    if (fresh && target) target.replaceWith(fresh);
    // is-empty klasa na rootu
    var freshRoot = tmp.querySelector('[data-natta-cart-drawer]');
    if (freshRoot) d.classList.toggle('is-empty', freshRoot.classList.contains('is-empty'));
    window.NattaEvents.publish('dom:updated', d);
  }

  function fetchCartState() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function afterMutation(sections, cartObj, openAfter) {
    if (sections && sections[SECTION]) renderSection(sections[SECTION]);
    // Fioka se otvara odmah: sadrzaj je vec stigao uz /cart/add. Ranije je
    // otvaranje cekalo jos i /cart.js (samo za broj na ikoni), pa je na
    // mobilnoj mrezi kupac 2-3 sekunde gledao nepromijenjenu stranicu
    // (vlasnik, 9. 10. 2026). Bez sekcije u odgovoru ostaje stari redoslijed.
    var early = openAfter && sections && sections[SECTION];
    if (early) open();
    var ready = cartObj ? Promise.resolve(cartObj) : fetchCartState();
    return ready.then(function (cart) {
      window.NattaEvents.publish('cart:change', cart);
      if (openAfter && !early) open();
      return cart;
    });
  }

  /* ---------- API ---------- */
  function add(items, opts) {
    opts = opts || {};
    return enqueue(function () {
      return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: [SECTION] }),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) throw new Error(res.description || 'Greška pri dodavanju');
          return afterMutation(res.sections, null, opts.open !== false);
        });
    });
  }

  function change(key, quantity) {
    return enqueue(function () {
      return fetch((window.routes && window.routes.cart_change_url) || '/cart/change', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: [SECTION] }),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          return afterMutation(res.sections, res, false);
        });
    });
  }

  /* Kolicina se racuna iz zeljene (pending) vrijednosti, ne iz DOM-a. */
  function changeBy(key, delta, domQty) {
    var base = pendingQty[key] != null ? pendingQty[key] : parseInt(domQty, 10) || 0;
    var next = Math.max(0, base + delta);
    pendingQty[key] = next;
    inflight[key] = (inflight[key] || 0) + 1;
    function settle() {
      inflight[key] -= 1;
      if (inflight[key] <= 0) { delete inflight[key]; delete pendingQty[key]; }
    }
    return change(key, next).then(settle, settle);
  }

  window.NattaCart = { add: add, change: change, open: open, close: close };

  /* ---------- event delegacija ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-natta-cart-open]')) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-natta-cart-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var qtyBtn = e.target.closest('[data-cart-qty-change]');
    if (qtyBtn) {
      changeBy(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.cartQtyChange, 10) || 0, qtyBtn.dataset.qty);
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      change(removeBtn.dataset.key, 0);
      return;
    }

    var upsell = e.target.closest('[data-cart-upsell]');
    if (upsell) {
      // Ciljana kolicina dolazi iz Liquida (trenutna + 1). Ranije je bilo
      // tvrdo 2 — a poziv „treci gratis" stoji upravo na liniji koja vec ima
      // 2 komada, pa bi klik vratio kolicinu na 2 umjesto da doda treci.
      // Dvoklik ne smije dodati dva komada; fioka se poslije izmjene ionako
      // iscrta iznova, pa se dugme vraca samo ako zahtjev padne.
      if (upsell.disabled) return;
      upsell.disabled = true;
      change(upsell.dataset.key, parseInt(upsell.dataset.qty, 10) || 2)
        .catch(function () { upsell.disabled = false; });
      return;
    }

    var addVariant = e.target.closest('[data-cart-add-variant]');
    if (addVariant) {
      e.preventDefault();
      var id = parseInt(addVariant.dataset.cartAddVariant, 10);
      var quantity = parseInt(addVariant.dataset.quantity || '1', 10);
      if (!id) return;
      addVariant.disabled = true;
      addVariant.classList.add('is-busy');
      addVariant.setAttribute('aria-busy', 'true');
      var addLabel = addVariant.textContent;
      add([{ id: id, quantity: quantity }])
        .catch(function () {
          // Ranije bez .catch(): varijanta se rasproda izmedju rendera i
          // klika, dugme trepne i nista se ne desi — bez ijedne poruke.
          addVariant.textContent = 'Nije uspjelo';
          setTimeout(function () { addVariant.textContent = addLabel; }, 2500);
        })
        .finally(function () {
          addVariant.disabled = false;
          addVariant.classList.remove('is-busy');
          addVariant.removeAttribute('aria-busy');
        });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawer();
      if (d && d.classList.contains('is-open')) close();
    }
  });
})();

/* ===================== natta-cod.js ===================== */
/* ============================================================
   NATTA Form — narudžba pouzećem u draweru (handoff §2.2)
   Korpa -> forma -> potvrda, bez izlaska iz drawera.
   Nema e-maila i nema registracije: telefon je ključno polje
   jer kroz njega ide potvrda narudžbe.
   ============================================================ */
(function () {
  'use strict';

  var panel = document.querySelector('[data-cod-panel]');
  if (!panel) return;

  var drawer = document.querySelector('[data-natta-cart-drawer]');
  var form = panel.querySelector('[data-cod-form]');
  var foot = panel.querySelector('.n-cod__foot');
  var done = panel.querySelector('[data-cod-done]');
  var errEl = panel.querySelector('[data-cod-error]');
  var submitBtn = panel.querySelector('[data-cod-submit]');

  // Dugme je sada type=submit unutar forme (ranije je stajalo IZVAN
  // <form>, pa Enter u polju nije radio nista). Enter zato okida
  // submit dogadjaj — presrecemo ga i vodimo kroz istu putanju
  // kao klik, inace bi stranica navigirala.
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn) submitBtn.click();
    });
  }

  /* obavezna polja — §2.2: ime, telefon, adresa i grad */
  var REQUIRED = ['name', 'phone', 'address', 'city'];

  function field(k) { return panel.querySelector('[data-cod-field="' + k + '"]'); }
  function content() { return drawer && drawer.querySelector('[data-natta-cart-content]'); }

  function showCart() {
    panel.hidden = true;
    var c = content();
    if (c) c.hidden = false;
  }

  function showForm() {
    var c = content();
    if (c) c.hidden = true;
    panel.hidden = false;
    if (form) form.hidden = false;
    if (foot) foot.hidden = false;
    if (done) done.hidden = true;
    var first = field('name');
    if (first) first.focus({ preventScroll: true });
  }

  function showDone() {
    if (form) form.hidden = true;
    if (foot) foot.hidden = true;
    if (done) done.hidden = false;
  }

  function setError(msg) {
    if (!errEl) return;
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
  }

  function values() {
    var out = {};
    ['name', 'phone', 'address', 'city', 'note'].forEach(function (k) {
      var el = field(k);
      out[k] = el ? el.value.trim() : '';
    });
    return out;
  }

  function markInvalid(v) {
    var bad = null;
    REQUIRED.forEach(function (k) {
      var el = field(k);
      if (!el) return;
      var empty = !v[k];
      el.classList.toggle('is-invalid', empty);
      if (empty && !bad) bad = el;
    });
    return bad;
  }

  /* Bez backenda tema ne moze sama kreirati narudzbu. Dvije podrzane putanje (§7):
     (a) prazan endpoint -> podaci idu u cart atribute, kupac ide na Shopify
         checkout gdje je pouzece jedina metoda;
     (b) postavljen App Proxy endpoint -> POST na njega, narudzba se kreira kao
         draft order i kupac nikad ne napusta drawer. */
  function endpoint() {
    return (panel.dataset.codEndpoint || '').trim();
  }

  function saveAttributes(v) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Način plaćanja': 'Pouzeće',
          'Ime i prezime': v.name,
          Telefon: v.phone,
          Adresa: v.address,
          Grad: v.city,
          Napomena: v.note
        }
      })
    });
  }

  document.addEventListener('click', function (e) {
    var codOpen = e.target.closest('[data-cod-open]');
    if (codOpen) {
      e.preventDefault();
      // Dugme na /cart stranici je izvan fioke, a forma zivi samo u fioci —
      // bez ovoga bi se forma „otvorila" u zatvorenoj fioci i klik ne bi
      // pokazao nista.
      if (drawer && !drawer.contains(codOpen) && window.NattaCart && window.NattaCart.open) {
        window.NattaCart.open();
      }
      showForm();
      return;
    }
    if (e.target.closest('[data-cod-back]')) {
      e.preventDefault();
      showCart();
      return;
    }

    var submit = e.target.closest('[data-cod-submit]');
    if (!submit) return;
    e.preventDefault();

    var v = values();
    var bad = markInvalid(v);
    if (bad) {
      setError('Molimo popunite ime, telefon, adresu i grad.');
      bad.focus({ preventScroll: true });
      return;
    }
    setError('');

    submit.disabled = true;
    var prevLabel = submit.textContent;
    submit.textContent = 'Šaljem narudžbu…';

    function fail() {
      submit.disabled = false;
      submit.textContent = prevLabel;
      setError('Narudžba nije poslana. Pokušajte ponovo ili nas nazovite.');
    }

    saveAttributes(v)
      .then(function (r) {
        if (!r.ok) throw new Error('cart update failed');
        var url = endpoint();
        if (!url) {
          // (a) Shopify checkout — pouzece je tamo jedina metoda
          window.location.href = '/checkout';
          return null;
        }
        // (b) draft order preko App Proxyja
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(v)
        }).then(function (res) {
          if (!res.ok) throw new Error('endpoint failed');
          showDone();
        });
      })
      .catch(fail);
  });

  /* ukupan iznos u COD panelu prati korpu */
  if (window.NattaEvents) {
    window.NattaEvents.subscribe('cart:change', function (cart) {
      if (!cart || typeof cart.total_price !== 'number') return;
      var m = (window.NattaMoney && window.NattaMoney.format) || null;
      if (!m) return;
      panel.querySelectorAll('[data-cod-total], [data-cod-done-total]').forEach(function (el) {
        el.textContent = m(cart.total_price);
      });
    });
  }

  /* zatvaranje drawera vraca panel u pocetno stanje */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-natta-cart-close]')) {
      setTimeout(function () {
        showCart();
        if (form) { form.hidden = false; form.reset(); }
        if (foot) foot.hidden = false;
        if (done) done.hidden = true;
        setError('');
        REQUIRED.forEach(function (k) {
          var el = field(k);
          if (el) el.classList.remove('is-invalid');
        });
      }, 250);
    }
  });
})();

/* ===================== natta-sections.js ===================== */
/* ============================================================
   NATTA Form — JS za below-fold / content sekcije:
   before/after slider, video modal, foto-recenzije (filter +
   lightbox), cross-sell preporuke.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- before/after drag ---------- */
  document.querySelectorAll('[data-natta-ba]').forEach(function (ba) {
    if (ba.dataset.baInit) return;
    ba.dataset.baInit = '1';
    var before = ba.querySelector('[data-ba-before]');
    var divider = ba.querySelector('[data-ba-divider]');
    var handle = ba.querySelector('[data-ba-handle]');
    if (!before || !divider || !handle) return; // nepotpun markup -> ne kaci listenere
    var dragging = false;

    function move(clientX) {
      var r = ba.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      before.style.width = pct + '%';
      divider.style.left = pct + '%';
      handle.style.left = pct + '%';
    }

    ba.addEventListener('mousedown', function (e) { dragging = true; move(e.clientX); });
    ba.addEventListener('touchstart', function (e) { dragging = true; move(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX); });
    window.addEventListener('touchmove', function (e) { if (dragging) move(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('touchend', function () { dragging = false; });
  });

  /* ---------- video / UGC modal ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-ugc-open]');
    if (openBtn) {
      var section = openBtn.closest('section');
      var modal = section && section.querySelector('[data-ugc-modal]');
      if (!modal) return;
      var video = modal.querySelector('[data-ugc-video]');
      var frame = modal.querySelector('[data-ugc-frame]');
      var url = openBtn.dataset.videoUrl;
      // Bez videa nema sta prikazati — ranije se otvarao modal sa
      // placeholder tekstom. Plocica se sada i ne renderuje bez videa,
      // ovo je druga brana za isti slucaj.
      if (!url || !video) return;
      if (frame) frame.classList.toggle('is-vertical', openBtn.dataset.vertical === '1');
      video.src = url;
      video.hidden = false;
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('n-no-scroll');
      return;
    }
    var closeBtn = e.target.closest('[data-ugc-close]');
    if (closeBtn) {
      var m = closeBtn.closest('[data-ugc-modal]');
      if (!m) return;
      var v = m.querySelector('[data-ugc-video]');
      if (v) { v.pause(); v.removeAttribute('src'); }
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('n-no-scroll');
    }
  });

  /* ---------- foto-recenzije: filter + lightbox ---------- */
  document.querySelectorAll('[data-natta-reviews]').forEach(function (section) {
    if (section.dataset.reviewsInit) return;
    section.dataset.reviewsInit = '1';
    var cards = section.querySelectorAll('[data-review-rating]');
    var empty = section.querySelector('[data-reviews-empty]');

    section.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-review-filter]');
      if (chip) {
        section.querySelectorAll('[data-review-filter]').forEach(function (c) {
          c.classList.toggle('is-active', c === chip);
        });
        var f = chip.dataset.reviewFilter;
        var visible = 0;
        cards.forEach(function (card) {
          var r = parseInt(card.dataset.reviewRating, 10);
          var show = f === 'all' || (f === '5' && r === 5) || (f === '4plus' && r >= 4);
          card.hidden = !show;
          if (show) visible++;
        });
        if (empty) empty.hidden = visible > 0;
        return;
      }

      var photo = e.target.closest('[data-review-photo]');
      if (photo) {
        var lb = section.querySelector('[data-reviews-lightbox]');
        var img = lb && lb.querySelector('[data-rlb-img]');
        if (!lb || !img) return;
        img.src = photo.dataset.src;
        img.alt = photo.dataset.alt || 'Fotografija kupca';
        lb.classList.add('is-open');
        lb.setAttribute('aria-hidden', 'false');
        document.body.classList.add('n-no-scroll');
        return;
      }

      if (e.target.closest('[data-rlb-close]')) {
        var l = section.querySelector('[data-reviews-lightbox]');
        if (l) {
          l.classList.remove('is-open');
          l.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('n-no-scroll');
        }
      }
    });
  });

  /* ---------- cross-sell preporuke (Shopify recommendations) ---------- */
  document.querySelectorAll('[data-natta-cross-sell][data-url]').forEach(function (section) {
    if (section.dataset.xsInit) return;
    section.dataset.xsInit = '1';
    // Shopify /recommendations racuna preporuke pri PRVOM pozivu i tada
    // zna vratiti prazan grid; tek drugi poziv ima sadrzaj. Zato dva
    // pokusaja prije nego sekciju sakrijemo.
    function load(attempt) {
      fetch(section.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var tmp = document.createElement('div');
          tmp.innerHTML = text;
          var fresh = tmp.querySelector('[data-cross-sell-grid]');
          var target = section.querySelector('[data-cross-sell-grid]');
          if (fresh) {
            // Isti model postoji kao dva proizvoda (npr. ComfortLift i
            // ComfortLift 1), pa je preporuka nudila „isti" grudnjak koji
            // kupac vec gleda. Izbacujemo karticu sa istim nazivom kao H1 i
            // ostavljamo najvise 4.
            var h1 = document.querySelector('h1');
            var own = h1 ? h1.textContent.trim().toLowerCase() : '';
            Array.prototype.slice.call(fresh.children).forEach(function (card) {
              var name = card.querySelector('.n-card__name');
              if (own && name && name.textContent.trim().toLowerCase() === own) card.remove();
            });
            while (fresh.children.length > 4) fresh.removeChild(fresh.lastElementChild);
          }
          if (fresh && target && fresh.children.length) {
            // Kartice stizu prije nego kupac doskroluje (vidi start ispod),
            // pa slike ne smiju cekati „lazy" — inace je mreza par sekundi
            // stajala sa praznim sivim poljima (vlasnik, 9. 10. 2026).
            fresh.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
              img.loading = 'eager';
            });
            target.replaceWith(fresh);
            return;
          }
          if (attempt < 2) {
            setTimeout(function () { load(attempt + 1); }, 700);
            return;
          }
          // Bez JS-a sekciju sakriva <noscript> stil, ne klasa — klasa
          // sa display:none ili visibility:hidden sprijeci observer.
          if (!target || !target.children.length) section.hidden = true;
        })
        .catch(function () {
          if (attempt < 2) setTimeout(function () { load(attempt + 1); }, 700);
        });
    }

    // Ranije je ucitavanje krenulo tek 400px prije sekcije: zahtjev za
    // preporuke + slike su trajali duze od skrola, pa je kupac dolazio na
    // prazne kartice. Sada krece cim se stranica ucita (ne takmici se sa
    // glavnom slikom proizvoda), a observer sa velikom marginom ostaje
    // kao raniji okidac za brzo skrolovanje.
    var started = false;
    function start() {
      if (started) return;
      started = true;
      observer.disconnect();
      load(1);
    }
    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) start();
      },
      { rootMargin: '0px 0px 1600px 0px' }
    );
    observer.observe(section);
    if (document.readyState === 'complete') {
      setTimeout(start, 300);
    } else {
      window.addEventListener('load', function () { setTimeout(start, 300); });
    }

    // IntersectionObserver ne okine ako dokument nije vidljiv (pozadinski
    // tab, prerender) ili ako viewport nema visinu. Bez ove brane
    // cross-sell u tim slucajevima ostane trajno prazan. Zahtjev je jedan
    // i mali, pa je jeftinije uciti ga nego se oslanjati samo na observer.
    setTimeout(function () {
      if (started) return;
      started = true;
      observer.disconnect();
      load(1);
    }, 3000);
  });
})();

/* ===================== natta-product.js ===================== */
/* ============================================================
   NATTA Form — PDP "Hibrid 2.0" logika
   Boja → galerija set, veličina → dostupnost, bundle tier → CTA,
   sticky bars, lightbox (zoom), fit-finder modal.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-natta-pdp]');
  if (!root || root.dataset.nattaPdpInit) return;
  root.dataset.nattaPdpInit = '1';

  var data = JSON.parse(root.querySelector('[data-pdp-json]').textContent);
  function money(cents) {
    if (window.NattaMoney && window.NattaMoney.format) return window.NattaMoney.format(cents);
    return 'KM ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ---------- state ---------- */
  var state = {
    color: null,
    size: null,
    // Treca opcija (Rukavi / Vrsta / Korpica). Bez nje je currentVariant()
    // uzimao PRVU varijantu koja odgovara boji i velicini — trecu je birao
    // .find(), ne kupac.
    extra: null,
    tierQty: 1,
    tierPct: 0,
    // „2+1 GRATIS": broj besplatnih komada u paketu (popust u korpi).
    tierFree: 0,
    // Paket sa miksom: svaki komad ima svoju boju i velicinu (kao Kaching
    // Bundles). Vlasnik, 9. 10. 2026: „2+1 moze samo istu boju da uzme".
    // Automatski popust u korpi vazi i za razlicite varijante (provjereno
    // u usability testu: tri boje -> treci gratis).
    mix: null,
    mixRow0Touched: false,
  };

  var activeSwatch = root.querySelector('[data-pdp-shade].is-active');
  if (activeSwatch) state.color = activeSwatch.dataset.pdpShade;
  var activeSize = root.querySelector('[data-pdp-size].is-active');
  if (activeSize) state.size = activeSize.dataset.pdpSize;
  // Je li kupac stvarno izabrao velicinu. Markup je vise ne bira unaprijed
  // (vidi komentar uz cipove u main-product.liquid), pa se ovo pali tek na
  // klik. Bez zastavice bi je vratio sync ispod: resolveVariant nadje
  // varijantu i upise njenu velicinu nazad u stanje — pa bi XS opet bio
  // „izabran", samo nevidljivo.
  var sizeChosen = !!activeSize;
  var activeExtra = root.querySelector('[data-pdp-extra].is-active');
  if (activeExtra) state.extra = activeExtra.dataset.pdpExtra;

  var lastChanged = null;
  var pendingGalleryResync = false;

  function matches(v, opts) {
    return (
      (opts.color == null || v.color === opts.color) &&
      (opts.size == null || v.size === opts.size) &&
      (opts.extra == null || v.extra === opts.extra)
    );
  }

  // Kad izabrana kombinacija ne postoji (npr. „Kratki Rukavi" nema u
  // „Tamno Braon"), currentVariant() je vracao null i update() bi tiho
  // izasao — kupcu bi ostala PRETHODNA varijanta, a on misli da je
  // promijenio izbor. Zato popustamo ogranicenja: ono sto je kupac
  // upravo dirnuo se cuva, ostalo se prilagodjava, pa se stanje sinhronizuje.
  function resolveVariant(changed) {
    var want = { color: state.color, size: state.size, extra: state.extra };
    var exact = data.variants.find(function (v) { return matches(v, want); });
    if (exact) return exact;

    var keys = ['color', 'size', 'extra'].filter(function (k) { return k !== changed; });
    // Svi podskupovi, poredani po broju ispustenih ogranicenja. Ranije je
    // ovo koristilo slice(), koji daje samo SUSJEDNE podnizove — pa se
    // kombinacija ['color','extra'] nikad nije probala.
    var subsets = [];
    for (var mask = 1; mask < (1 << keys.length); mask++) {
      var set = [];
      for (var b = 0; b < keys.length; b++) {
        if (mask & (1 << b)) set.push(keys[b]);
      }
      subsets.push(set);
    }
    subsets.sort(function (a, b) { return a.length - b.length; });
    for (var si = 0; si < subsets.length; si++) {
      var relaxed = { color: want.color, size: want.size, extra: want.extra };
      subsets[si].forEach(function (k) { relaxed[k] = null; });
      var hit = data.variants.find(function (v) {
        return matches(v, relaxed) && (v.available || v.preorder);
      }) || data.variants.find(function (v) { return matches(v, relaxed); });
      if (hit) return hit;
    }
    return data.variants.find(function (v) { return v.available || v.preorder; }) || data.variants[0] || null;
  }

  function currentVariant() {
    var v = resolveVariant(lastChanged);
    if (v) {
      // Ako je resolveVariant morao promijeniti boju da bi nasao postojecu
      // kombinaciju, galerija to mora pratiti — inace kupac gleda
      // fotografije jedne boje dok u korpu ide druga.
      var colorChanged = v.color && v.color !== state.color;
      if (v.color) state.color = v.color;
      if (v.size && sizeChosen) state.size = v.size;
      if (v.extra) state.extra = v.extra;
      if (colorChanged) pendingGalleryResync = true;
    }
    return v || null;
  }

  function variantForSize(size) {
    return data.variants.find(function (v) {
      return (
        (!state.color || v.color === state.color) &&
        (!state.extra || v.extra === state.extra) &&
        v.size === size
      );
    });
  }

  /* ---------- paket sa miksom (2+1: boja i velicina po komadu) ---------- */
  var mixBox = root.querySelector('[data-pdp-mix]');
  var mixColors = [];
  data.variants.forEach(function (v) {
    if (v.color && mixColors.indexOf(v.color) === -1) mixColors.push(v.color);
  });
  var mixSizes = (data.sizes && data.sizes.length) ? data.sizes.slice() : [];
  if (!mixSizes.length) {
    data.variants.forEach(function (v) {
      if (v.size && mixSizes.indexOf(v.size) === -1) mixSizes.push(v.size);
    });
  }

  function mixVariant(row) {
    return data.variants.find(function (v) {
      return (!mixColors.length || v.color === row.color) &&
        (!mixSizes.length || v.size === row.size) &&
        (!state.extra || !v.extra || v.extra === state.extra);
    }) || null;
  }

  function mixBuyable(v) {
    return !!(v && (v.available || v.preorder));
  }

  function mixInit() {
    var size = sizeChosen ? state.size : '';
    state.mix = [0, 1, 2].slice(0, state.tierQty).map(function () {
      return { color: state.color || mixColors[0] || '', size: size || '' };
    });
    state.mixRow0Touched = false;
  }

  function mixEsc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  // Slicica komada u izabranoj boji (vlasnik: „treba da se vidi boja,
  // tj slika"). Uzima se prva slika iz galerije koja pripada toj boji —
  // ista grupa koju kupkinja vidi gore — a bez slike kruzic boje sa
  // plocice (isti hex kao swatch).
  function mixThumb(color) {
    var key = String(color || '').toLowerCase();
    var hit = null;
    for (var k = 0; k < slides.length && !hit; k++) {
      var sh = (slides[k].getAttribute('data-shades') || '').toLowerCase().split('|');
      if (key && sh.indexOf(key) !== -1 && slides[k].querySelector('img')) hit = slides[k];
    }
    if (hit) {
      var im = hit.querySelector('img');
      var src = im.getAttribute('src') || im.currentSrc;
      if (src) return '<img src="' + mixEsc(src) + '" alt="" loading="lazy">';
    }
    var sw = null;
    root.querySelectorAll('[data-pdp-shade]').forEach(function (b) {
      if (!sw && b.getAttribute('data-pdp-shade') === color) sw = b;
    });
    var bg = sw ? (sw.style.backgroundImage && sw.style.backgroundImage !== 'none' ? 'background-image:' + sw.style.backgroundImage : 'background-color:' + sw.style.backgroundColor) : '';
    return '<span class="n-mix__dot" style="' + mixEsc(bg) + '"></span>';
  }

  function mixRowHtml(row, i) {
    var free = i >= state.tierQty - state.tierFree;
    var h = '<div class="n-mix__row' + (row.err ? ' is-missing' : '') + '" data-mix-row="' + i + '">';
    h += '<span class="n-mix__n">' + (i + 1) + '.</span>';
    if (mixColors.length) h += '<span class="n-mix__img" aria-hidden="true">' + mixThumb(row.color) + '</span>';
    if (mixColors.length) {
      h += '<label class="n-mix__field"><span class="visually-hidden">Boja ' + (i + 1) + '. komada</span>' +
        '<select data-mix-color="' + i + '">';
      mixColors.forEach(function (c) {
        var any = data.variants.some(function (v) { return v.color === c && mixBuyable(v); });
        h += '<option value="' + mixEsc(c) + '"' + (c === row.color ? ' selected' : '') + (any ? '' : ' disabled') + '>' +
          mixEsc(c) + (any ? '' : ' — rasprodato') + '</option>';
      });
      h += '</select></label>';
    }
    if (mixSizes.length) {
      h += '<label class="n-mix__field n-mix__field--size"><span class="visually-hidden">Veličina ' + (i + 1) + '. komada</span>' +
        '<select data-mix-size="' + i + '">' + mixSizeOptions(row);
      h += '</select></label>';
    }
    h += '<span class="n-mix__price' + (free ? ' is-free' : '') + '">' + (free ? 'GRATIS' : '') + '</span>';
    h += '</div>';
    return h;
  }

  function renderMix(forVariant) {
    if (!mixBox) return;
    var on = !!state.tierFree && state.tierQty > 1 && (mixColors.length > 1 || mixSizes.length > 0);
    mixBox.hidden = !on;
    if (!on) return;
    if (!state.mix || state.mix.length !== state.tierQty) mixInit();
    // Prvi red prati izbor gore dok ga kupac ne promijeni u samom redu.
    if (!state.mixRow0Touched) {
      state.mix[0].color = state.color || state.mix[0].color;
      if (sizeChosen && state.size) state.mix[0].size = state.size;
    }
    var price = (forVariant || {}).price || 0;
    var html = '<p class="n-mix__head">Izaberite boju i veličinu za svaki komad</p>';
    state.mix.forEach(function (row, i) { html += mixRowHtml(row, i); });
    mixBox.innerHTML = html;
    mixBox.querySelectorAll('.n-mix__price:not(.is-free)').forEach(function (el) {
      el.textContent = money(price);
    });
  }

  function mixMissing() {
    if (!state.mix) return false;
    var miss = false;
    state.mix.forEach(function (row) {
      row.err = !mixBuyable(mixVariant(row));
      if (row.err) miss = true;
    });
    return miss;
  }

  function mixItems() {
    var byId = {};
    var order = [];
    state.mix.forEach(function (row) {
      var v = mixVariant(row);
      if (!byId[v.id]) { byId[v.id] = 0; order.push(v.id); }
      byId[v.id] += 1;
    });
    return order.map(function (id) { return { id: id, quantity: byId[id] }; });
  }

  // Opcije velicine za jedan red (zavise od boje tog reda).
  function mixSizeOptions(row) {
    var h = '<option value=""' + (row.size ? '' : ' selected') + '>Veličina</option>';
    mixSizes.forEach(function (z) {
      var v = mixVariant({ color: row.color, size: z });
      var ok = mixBuyable(v);
      var pre = ok && v.preorder;
      h += '<option value="' + mixEsc(z) + '"' + (z === row.size ? ' selected' : '') + (ok ? '' : ' disabled') + '>' +
        mixEsc(z) + (pre ? ' (u dolasku)' : '') + (ok ? '' : ' — nema') + '</option>';
    });
    return h;
  }

  if (mixBox) {
    // Izbor u redu NE crta red iznova i ne vraca fokus na polje: na
    // telefonu fokus na <select> ponovo otvara birac, pa se lista boja
    // otvarala opet odmah poslije izbora (vlasnik, 9. 10. 2026). Mijenja
    // se samo ono sto zavisi od izbora: slicica i spisak velicina.
    mixBox.addEventListener('change', function (e) {
      var c = e.target.closest('[data-mix-color]');
      var z = e.target.closest('[data-mix-size]');
      if (!c && !z) return;
      var i = parseInt((c || z).getAttribute(c ? 'data-mix-color' : 'data-mix-size'), 10);
      var row = state.mix[i];
      var rowEl = mixBox.querySelector('[data-mix-row="' + i + '"]');
      if (i === 0) state.mixRow0Touched = true;
      if (c) {
        row.color = c.value;
        // Nova boja mozda nema tu velicinu — tada se velicina brise.
        if (row.size && !mixBuyable(mixVariant(row))) row.size = '';
        if (rowEl) {
          var img = rowEl.querySelector('.n-mix__img');
          if (img) img.innerHTML = mixThumb(row.color);
          var sizeSel = rowEl.querySelector('[data-mix-size]');
          if (sizeSel) sizeSel.innerHTML = mixSizeOptions(row);
        }
      } else {
        row.size = z.value;
      }
      row.err = false;
      if (rowEl) rowEl.classList.remove('is-missing');
    });
  }

  /* ---------- galerija ---------- */
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]'));
  var thumbsWrap = root.querySelector('[data-pdp-thumbs]');

  var slidesWrap = root.querySelector('[data-pdp-slides]');
  var filterByColor = !slidesWrap || slidesWrap.dataset.filterColor !== '0';
  // Koliko slika prikazati kad oznake po boji nisu upotrebljive (vidi
  // visibleSlides). Deset je dovoljno da kupac vidi proizvod iz vise uglova,
  // a da desktop galerija ne postane beskrajna traka.
  var FALLBACK_MAX = 10;

  function visibleSlides() {
    if (!filterByColor) return slides;
    var colorDown = (state.color || '').toLowerCase();
    // slike povezane sa izabranom bojom (ALT tekst ili dodjela varijanti)
    var own = slides.filter(function (s) {
      var shades = (s.dataset.shades || '').split('|').filter(Boolean);
      return colorDown && shades.indexOf(colorDown) >= 0;
    });
    // Jedna slika po boji znaci da oznaka dolazi SAMO iz dodjele varijanti —
    // Shopify vezuje tacno jednu sliku po varijanti — a ne iz ALT teksta.
    // Filtriranje po tako mrsavom signalu sakrije sve ostale slike: mjereno,
    // 84 od 85 proizvoda sa vise boja prikazivalo je tacno JEDNU sliku kad
    // se boja izabere, jer im svih 20-70 slika ima isti genericki ALT
    // (naziv proizvoda) i dobavljacko ime fajla.
    //
    // Zato: filtriraj samo kad oznaka stvarno nesto grupise (2+ slike).
    // Inace prikazi cijelu galeriju, ali tu jednu tacnu stavi PRVU, da
    // kupac i dalje prvo vidi izabranu boju.
    if (own.length === 1) {
      // Na desktopu (min-width: 768px) CSS prikazuje SVE is-visible slajdove
      // jedan ispod drugog. Vratiti cijelu galeriju znaci naslagati i do 74
      // slike — zamijenili bismo jedan problem drugim. Zato ogranicen isjecak
      // koji POCINJE od tacne slike: dobavljaci slike uploaduju grupisane po
      // boji, pa su susjedne najcesce ista boja. I kad nisu, kupac dobije
      // desetak umjesto jedne.
      var idx = slides.indexOf(own[0]);
      var window_ = slides.slice(idx, idx + FALLBACK_MAX);
      if (window_.length < FALLBACK_MAX) {
        var dopuna = slides.slice(0, idx).slice(-(FALLBACK_MAX - window_.length));
        window_ = window_.concat(dopuna.filter(function (s) { return window_.indexOf(s) < 0; }));
      }
      return window_;
    }
    if (!own.length) {
      // boja nema povezanih slika -> prikaži sve (fallback, galerija nije prazna)
      return slides;
    }
    // slike označene da se UVIJEK prikazuju (npr. proof slajd) idu uz boju
    var always = slides.filter(function (s) {
      return s.dataset.always === '1';
    });
    var list = own.concat(always);
    return list.filter(function (s, i) { return list.indexOf(s) === i; });
  }

  var galleryList = [];
  var activeIdx = 0;

  function renderGallery(resetIndex) {
    galleryList = visibleSlides();
    if (resetIndex) activeIdx = 0;
    slides.forEach(function (s) {
      s.classList.remove('is-visible', 'is-active', 'is-first');
      s.style.order = '';
    });
    galleryList.forEach(function (s, i) {
      s.classList.add('is-visible');
      // visibleSlides() vraca boju PRVO pa tek onda „uvijek vidljive"
      // grafike. Bez `order` mreza ih je i dalje slagala redom iz HTML-a,
      // pa je pod „Crna" prvo stajala braon grafika (ona je 3. medij), a
      // crne fotografije tek ispod. Kupac otvori crnu i vidi braon.
      s.style.order = String(i);
      if (i === 0) s.classList.add('is-first');
      if (i === activeIdx) s.classList.add('is-active');
    });
    // thumbs (mobile)
    if (thumbsWrap) {
      thumbsWrap.innerHTML = '';
      galleryList.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'n-pdp__thumb' + (i === activeIdx ? ' is-active' : '');
        b.setAttribute('aria-label', 'Slika ' + (i + 1));
        var img = s.querySelector('img');
        // Video slajd nema <img>, pa je slicica bila prazan sivi kvadrat
        // (usability, 9. 10. 2026). Uzima se poster videa.
        var vid = s.querySelector('video');
        var thumbSrc = img ? (img.currentSrc || img.src) : (vid && vid.getAttribute('poster'));
        if (thumbSrc) {
          var t = document.createElement('img');
          t.src = thumbSrc;
          t.alt = '';
          t.loading = 'lazy';
          b.appendChild(t);
          if (!img) b.classList.add('n-pdp__thumb--video');
        } else {
          b.classList.add('n-pdp__thumb--ph');
        }
        b.addEventListener('click', function () {
          activeIdx = i;
          renderGallery(false);
        });
        thumbsWrap.appendChild(b);
      });
      // Aktivna slicica u vidno polje trake (vazno kad se lista prstom).
      var act = thumbsWrap.querySelector('.is-active');
      if (act && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
        thumbsWrap.scrollLeft = Math.max(0, act.offsetLeft - (thumbsWrap.clientWidth - act.offsetWidth) / 2);
      }
    }
  }

  // Listanje galerije prstom na telefonu (usability, 9. 10. 2026: „galerija
  // se ne prevlaci" — radilo je samo u uvecanom prikazu). Samo vodoravni
  // potez mijenja sliku; uspravni ostaje skrol stranice. Na desktopu su
  // slike u mrezi, pa tamo nema sta listati.
  var slidesBox = root.querySelector('[data-pdp-slides]');
  if (slidesBox) {
    var gx = null;
    var gy = null;
    slidesBox.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || window.innerWidth >= 768) { gx = null; return; }
      gx = e.touches[0].clientX;
      gy = e.touches[0].clientY;
    }, { passive: true });
    slidesBox.addEventListener('touchend', function (e) {
      if (gx === null || galleryList.length < 2) return;
      var dx = e.changedTouches[0].clientX - gx;
      var dy = e.changedTouches[0].clientY - gy;
      gx = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
      var n = galleryList.length;
      activeIdx = ((activeIdx + (dx < 0 ? 1 : -1)) % n + n) % n;
      renderGallery(false);
    }, { passive: true });
  }

  /* ---------- lightbox ---------- */
  var lightbox = root.querySelector('[data-pdp-lightbox]');
  var lbImg = root.querySelector('[data-lightbox-img]');
  var lbCounter = root.querySelector('[data-lightbox-counter]');
  var lbHint = root.querySelector('[data-lightbox-hint]');
  var lbFrame = root.querySelector('[data-lightbox-frame]');
  var lbIndex = 0;
  var lbZoom = false;

  function lbSources() {
    return galleryList
      .map(function (s) { return s.dataset.src; })
      .filter(Boolean);
  }

  // Brzina (vlasnik: „modal je spor, sporo mijenja slike"): ranije se
  // tek na klik skidala slika od 1400px, a ona vec ucitana na stranici se
  // nije koristila. Sada se ODMAH prikaze slika koju preglednik vec ima
  // (iz galerije), velika se ucita u pozadini i zamijeni je, a susjedne
  // dvije se ucitavaju unaprijed — listanje je trenutno.
  var lbToken = 0;
  var lbCache = {};
  function lbPreload(src) {
    if (!src || lbCache[src]) return lbCache[src];
    var im = new Image();
    im.decoding = 'async';
    im.src = src;
    lbCache[src] = im;
    return im;
  }

  function lbShow(i) {
    if (!lbImg) return;
    var srcs = lbSources();
    if (!srcs.length) return;
    lbIndex = ((i % srcs.length) + srcs.length) % srcs.length;
    lbZoom = false;
    lbImg.style.transform = 'scale(1)';
    var hi = srcs[lbIndex];
    var token = ++lbToken;
    var cached = lbCache[hi];
    if (cached && cached.complete && cached.naturalWidth) {
      lbImg.src = hi;
    } else {
      var slide = galleryList[lbIndex];
      var low = slide && slide.querySelector('img');
      var lowSrc = low && low.complete && low.naturalWidth ? (low.currentSrc || low.src) : '';
      lbImg.src = lowSrc || hi;
      if (lowSrc) {
        var pre = lbPreload(hi);
        pre.addEventListener('load', function () {
          if (token === lbToken) lbImg.src = hi;
        }, { once: true });
      }
    }
    lbPreload(srcs[(lbIndex + 1) % srcs.length]);
    lbPreload(srcs[(lbIndex - 1 + srcs.length) % srcs.length]);
    if (lbCounter) lbCounter.textContent = lbIndex + 1 + ' / ' + srcs.length;
    if (lbHint) lbHint.textContent = '⌕ Uvećaj';
  }

  // Prelaz prstom na telefonu (lijevo/desno), dok slika nije uvecana.
  if (lbFrame) {
    var lbTouchX = null;
    var lbTouchY = null;
    lbFrame.addEventListener('touchstart', function (e) {
      if (lbZoom || e.touches.length !== 1) { lbTouchX = null; return; }
      lbTouchX = e.touches[0].clientX;
      lbTouchY = e.touches[0].clientY;
    }, { passive: true });
    lbFrame.addEventListener('touchend', function (e) {
      if (lbTouchX === null) return;
      var dx = e.changedTouches[0].clientX - lbTouchX;
      var dy = e.changedTouches[0].clientY - lbTouchY;
      lbTouchX = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        lbShow(lbIndex + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
  }

  function lbOpen(i) {
    if (!lightbox || !lbSources().length) return;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('n-no-scroll');
    lbShow(i);
  }

  function lbClose() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('n-no-scroll');
  }

  root.addEventListener('click', function (e) {
    var slide = e.target.closest('[data-pdp-slide]');
    if (slide && slide.classList.contains('is-active') && slide.dataset.src) {
      lbOpen(galleryList.indexOf(slide));
      return;
    }
    if (slide && !slide.classList.contains('is-active') && slide.classList.contains('is-visible')) {
      // desktop stacked: klik otvara lightbox na tom indeksu
      lbOpen(galleryList.indexOf(slide));
      return;
    }
    if (e.target.closest('[data-lightbox-close]')) { lbClose(); return; }
    if (e.target.closest('[data-lightbox-prev]')) { e.stopPropagation(); lbShow(lbIndex - 1); return; }
    if (e.target.closest('[data-lightbox-next]')) { e.stopPropagation(); lbShow(lbIndex + 1); return; }
  });

  if (lbImg) {
    lbImg.addEventListener('click', function (e) {
      e.stopPropagation();
      lbZoom = !lbZoom;
      lbImg.style.transform = lbZoom ? 'scale(2.4)' : 'scale(1)';
      if (lbHint) lbHint.textContent = lbZoom ? 'Klik za smanjenje' : '⌕ Uvećaj';
    });
    if (lbFrame) lbFrame.addEventListener('mousemove', function (e) {
      if (!lbZoom) return;
      var r = lbFrame.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      lbImg.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') lbClose();
    else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
    else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
  });

  /* ---------- UI update ---------- */
  var els = {
    price: root.querySelector('[data-pdp-price]'),
    compare: root.querySelector('[data-pdp-compare]'),
    save: root.querySelector('[data-pdp-save]'),
    shadeName: root.querySelector('[data-pdp-shade-name]'),
    availTitle: root.querySelector('[data-avail-title]'),
    availSub: root.querySelector('[data-avail-sub]'),
    availability: root.querySelector('[data-pdp-availability]'),
    lowStock: root.querySelector('[data-pdp-low-stock]'),
    cta: root.querySelector('[data-pdp-cta]'),
    ctaLabel: root.querySelector('[data-pdp-cta-label]'),
    variantInput: root.querySelector('[data-pdp-variant-input]'),
    qtyInput: root.querySelector('[data-pdp-qty-input]'),
    stickyPrice: root.querySelector('[data-pdp-sticky-price]'),
    stickyVariant: root.querySelector('[data-pdp-sticky-variant]'),
    stickyPriceD: root.querySelector('[data-pdp-sticky-price-d]'),
    freeship: root.querySelector('[data-pdp-freeship]'),
    saleBadges: root.querySelectorAll('[data-pdp-sale-badge]'),
    buyNow: root.querySelector('[data-pdp-buynow]'),
  };

  function tierTotal(variant) {
    if (state.tierFree) return variant.price * (state.tierQty - state.tierFree);
    return Math.round(variant.price * state.tierQty * (1 - state.tierPct / 100));
  }

  function updateBundleTiers(variant) {
    root.querySelectorAll('[data-tier-qty]').forEach(function (tier) {
      var qty = parseInt(tier.dataset.tierQty, 10);
      var pct = parseInt(tier.dataset.tierPct, 10);
      var free = parseInt(tier.dataset.tierFree || '0', 10);
      var total = free
        ? variant.price * (qty - free)
        : Math.round(variant.price * qty * (1 - pct / 100));
      var priceEl = tier.querySelector('[data-tier-price]');
      var compareEl = tier.querySelector('[data-tier-compare]');
      if (priceEl) priceEl.textContent = money(total);
      if (compareEl) compareEl.textContent = (pct > 0 || free > 0) ? money(variant.price * qty) : '';
      var on = qty === state.tierQty;
      tier.classList.toggle('is-active', on);
      tier.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function update() {
    var variant = currentVariant();

    // swatchevi / chips
    root.querySelectorAll('[data-pdp-shade]').forEach(function (b) {
      var on = b.dataset.pdpShade === state.color;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var anyPre = false;
    root.querySelectorAll('[data-pdp-size]').forEach(function (b) {
      var on = b.dataset.pdpSize === state.size;
      b.classList.toggle('is-active', on);
      if (b.getAttribute('role') === 'radio') b.setAttribute('aria-checked', on ? 'true' : 'false');
      var v = variantForSize(b.dataset.pdpSize);
      var soldOut = !v || (!v.available && !v.preorder);
      b.classList.toggle('is-soldout', soldOut);
      b.disabled = soldOut;
      // „u dolasku" na samom cipu: kupkinja vidi PRIJE izbora koja je
      // velicina na stanju, a koja ceka 10–15 dana (usability, 9. 10. 2026:
      // kod Ayle 12 od 15 kombinacija u dolasku, a cipovi to nisu pokazivali).
      var pre = !soldOut && !!(v && v.preorder);
      b.classList.toggle('is-preorder', pre);
      anyPre = anyPre || pre;
    });
    var preNote = root.querySelector('[data-pdp-size-prenote]');
    if (preNote) preNote.hidden = !anyPre;
    root.querySelectorAll('[data-pdp-extra]').forEach(function (b) {
      var val = b.dataset.pdpExtra;
      var on = val === state.extra;
      b.classList.toggle('is-active', on);
      if (b.getAttribute('role') === 'radio') b.setAttribute('aria-checked', on ? 'true' : 'false');
      // Ne oznacavamo kao rasprodato — druga boja moze imati tu opciju, a
      // resolveVariant ce boju prilagoditi. Oznacavamo samo ako je opcija
      // rasprodata u CIJELOM katalogu proizvoda.
      var anyLeft = data.variants.some(function (v) {
        return v.extra === val && (v.available || v.preorder);
      });
      b.classList.toggle('is-soldout', !anyLeft);
      b.disabled = !anyLeft;
    });
    if (pendingGalleryResync) {
      pendingGalleryResync = false;
      renderGallery(true);
    }
    if (els.shadeName && state.color) els.shadeName.textContent = state.color;

    if (!variant) return;

    // Paket sa miksom se crta prije natpisa dugmadi: u miksu velicinu
    // biraju redovi paketa, pa dugme ne smije traziti velicinu gore.
    renderMix(variant);

    // cijena
    if (els.price) els.price.textContent = money(variant.price);
    var hasCompare = data.campaign && variant.compareAtPrice > variant.price;
    if (els.compare) {
      els.compare.hidden = !hasCompare;
      if (hasCompare) els.compare.textContent = money(variant.compareAtPrice);
    }
    if (els.save) {
      els.save.hidden = !hasCompare;
      if (hasCompare) els.save.textContent = 'Ušteda ' + money(variant.compareAtPrice - variant.price);
    }
    els.saleBadges.forEach(function (b) {
      if (hasCompare) {
        b.hidden = false;
        b.textContent = '-' + Math.round(((variant.compareAtPrice - variant.price) / variant.compareAtPrice) * 100) + '%';
      } else {
        b.hidden = true;
      }
    });

    // dostupnost (tekstovi iz block settinga preko data-atributa)
    if (els.availability) {
      // Tek kad je velicina izabrana (vidi komentar u main-product.liquid).
      els.availability.hidden = needsSize();
      var pre = variant.preorder;
      var av = els.availability.dataset;
      els.availability.classList.toggle('is-preorder', !!pre);
      els.availability.classList.toggle('is-soldout', !variant.available);
      if (!variant.available) {
        els.availTitle.textContent = 'Rasprodato u ovoj kombinaciji';
        els.availSub.textContent = 'Izaberite drugu veličinu ili boju';
      } else if (pre) {
        els.availTitle.textContent = av.preorderTitle || 'Pretprodaja · 10–15 radnih dana';
        els.availSub.textContent = av.preorderSub || 'Šaljemo odmah po dolasku — ograničena količina';
      } else {
        els.availTitle.textContent = av.instockTitle || 'Na stanju · šaljemo u roku 24h';
        els.availSub.textContent = av.instockSub || 'Vrijedi za odabranu veličinu i boju';
      }
    }

    // low-stock pill (samo kampanja + stvarno niska zaliha)
    if (els.lowStock) els.lowStock.hidden = !(data.campaign && variant.lowStock);

    // Sticky dugme je ostajalo aktivno i na rasprodatom proizvodu: klik je
    // zvao addToCart() koji tiho izadje. Dugme koje ne radi nista i ne kaze
    // zasto. Glavni CTA je dobijao disabled, sticky nije.
    // Obje trake (mobilna i desktop) imaju svoje dugme. Ranije se pisalo
    // samo u PRVO (querySelector), pa je desktop dugme zauvijek ostajalo
    // „Dodaj u korpu" — i bez izabrane velicine i na rasprodatom komadu.
    var soldOutNow = !variant.available && !variant.preorder;
    var stickyText = soldOutNow
      ? 'Rasprodato'
      : ((needsSize() && !mixActive()) ? 'Izaberite veličinu' : stickyAddLabel());
    root.querySelectorAll('[data-pdp-sticky-add]').forEach(function (stickyAdd) {
      stickyAdd.disabled = soldOutNow;
      stickyAdd.textContent = stickyText;
    });

    // CTA (label + prikaz cijene iz block settinga preko data-atributa)
    var total = tierTotal(variant);
    if (els.ctaLabel && els.cta) {
      var ctaLabel = els.cta.dataset.ctaLabel || 'Dodaj u korpu';
      var showPrice = els.cta.dataset.ctaShowPrice !== '0';
      var soldoutLabel = els.cta.dataset.soldoutLabel || 'Rasprodato';
      if (!variant.available) {
        els.ctaLabel.textContent = soldoutLabel;
      } else if (needsSize() && !mixActive()) {
        els.ctaLabel.textContent = 'Izaberite veličinu';
      } else if (state.tierFree) {
        // Paket „2+1": cijena se ne pise u dugmetu jer korpa prvo zbroji
        // tri komada pa tek onda skine treci — kupac vidi tacan iznos u
        // izboru iznad dugmeta.
        els.ctaLabel.textContent = ctaLabel + ' · ' + state.tierQty + ' kom (treći gratis)';
      } else if (state.tierQty > 1) {
        // Dugme je pokazivalo SNIZENU cijenu (total), a addToCart salje samo
        // { id, quantity } — bez ikakvog popusta. Kupac je citao
        // „Dodaj 3 kom — 197,00 KM", a korpa naplatila 246,00.
        // Popust dolazi iz Shopify automatskih popusta i vidi se tek u korpi,
        // pa dugme prikazuje puni iznos.
        els.ctaLabel.textContent =
          ctaLabel + ' ' + state.tierQty + ' kom' +
          (showPrice ? ' — ' + money(variant.price * state.tierQty) : '');
      } else {
        els.ctaLabel.textContent = ctaLabel + (showPrice ? ' — ' + money(variant.price) : '');
      }
    }
    if (els.cta) els.cta.disabled = !variant.available;
    if (els.buyNow) els.buyNow.disabled = !variant.available;
    if (els.variantInput) els.variantInput.value = variant.id;
    if (els.qtyInput) els.qtyInput.value = state.tierQty;

    // bundle + freeship
    updateBundleTiers(variant);
    // Traka besplatne dostave prati KORPU, a ne izabranu varijantu — pa se
    // na promjenu velicine ili boje ne dira. Osvjezava je cart modul kad se
    // korpa stvarno promijeni.

    // sticky bars
    // Cijena u traci prati izabrani paket, ne jedan komad. Usability: kupac
    // izabere „3 komada · 2+1 GRATIS", glavno dugme kaze „3 kom (treci
    // gratis)", a traka na dnu i dalje „KM 49,90" — izgleda kao da izbor
    // nije prihvacen. Iznos je isti kao u izboru paketa (tierTotal: 2 x
    // cijena). Za postotne pakete traka pise puni iznos, kao i glavno dugme:
    // popust tamo dolazi iz Shopify automatskog popusta tek u korpi.
    var stickyTotal = stickyPriceCents(variant);
    if (els.stickyPrice) els.stickyPrice.textContent = money(stickyTotal);
    if (els.stickyVariant) els.stickyVariant.textContent = stickyVariantLabel(variant);
    if (els.stickyPriceD) {
      var stickyCompare = 0;
      if (state.tierFree) stickyCompare = variant.price * state.tierQty;
      else if (hasCompare) stickyCompare = variant.compareAtPrice * state.tierQty;
      els.stickyPriceD.innerHTML = money(stickyTotal) + (stickyCompare > stickyTotal ? ' <s>' + money(stickyCompare) + '</s>' : '');
    }
  }

  // Iznos koji sticky traka pokazuje — isto pravilo kao glavno dugme.
  function stickyPriceCents(variant) {
    if (state.tierFree) return tierTotal(variant);
    return variant.price * state.tierQty;
  }

  // Natpis sticky dugmeta u skladu sa glavnim: ista kolicina i isti
  // „(treci gratis)". Krace od glavnog jer je traka na 390px uska — bez
  // „u korpu", ali sa brojem komada, da kupac zna sta ce dodati.
  function stickyAddLabel() {
    if (state.tierFree) return 'Dodaj ' + state.tierQty + ' kom (treći gratis)';
    if (state.tierQty > 1) return 'Dodaj ' + state.tierQty + ' kom';
    return 'Dodaj u korpu';
  }

  /* ---------- eventi: boja / veličina / tier ---------- */
  root.addEventListener('click', function (e) {
    var shade = e.target.closest('[data-pdp-shade]');
    if (shade) {
      state.color = shade.dataset.pdpShade;
      lastChanged = 'color';
      renderGallery(true);
      update();
      return;
    }
    var size = e.target.closest('[data-pdp-size]');
    if (size) sizeChosen = true;
    if (size && !size.disabled) {
      state.size = size.dataset.pdpSize;
      lastChanged = 'size';
      update();
      return;
    }
    var extra = e.target.closest('[data-pdp-extra]');
    if (extra && !extra.disabled) {
      state.extra = extra.dataset.pdpExtra;
      lastChanged = 'extra';
      update();
      return;
    }
    var tier = e.target.closest('[data-tier-qty]');
    if (tier) {
      state.tierQty = parseInt(tier.dataset.tierQty, 10);
      state.tierPct = parseInt(tier.dataset.tierPct, 10);
      state.tierFree = parseInt(tier.dataset.tierFree || '0', 10);
      state.mix = null;
      update();
      return;
    }
  });

  /* ---------- add to cart ---------- */
  var form = root.querySelector('[data-pdp-form]');
  var flashTimer = null;
  var adding = false;

  // Proizvod ima velicine, a kupac nijednu nije izabrao. Ne dodajemo nista:
  // podrazumijevana velicina je uvijek prva u nizu (najcesce XS ili S), a
  // kod pouzeca pogresna velicina znaci odbijen paket.
  function needsSize() {
    var chips = root.querySelectorAll('[data-pdp-size-chips] [data-pdp-size]');
    return chips.length > 0 && (!sizeChosen || !state.size);
  }

  // U paketu sa miksom svaki komad mora imati velicinu (i boju koja postoji).
  function mixActive() {
    return !!(mixBox && !mixBox.hidden && state.mix && state.tierFree);
  }

  function askForMix() {
    renderMix(currentVariant());
    var bad = mixBox.querySelector('.n-mix__row.is-missing');
    try {
      var y = (bad || mixBox).getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: y, behavior: 'smooth' });
    } catch (err) { /* bez scrollTo */ }
    var sel = bad && (bad.querySelector('[data-mix-size]') || bad.querySelector('select'));
    if (sel && sel.focus) sel.focus({ preventScroll: true });
  }

  // Natpis varijante u mobilnoj sticky traci. Dok kupac nije izabrao
  // velicinu, resolveVariant() ipak vrati PRVU varijantu te boje (da bi
  // cijena i dostupnost imale od cega da se racunaju) — i njen naslov
  // „Crna / S" je pisao „Crna · S" u traci, kao da je S izabrano. Kupkinja
  // je to citala kao potvrdu izbora, a dugme je i dalje trazilo velicinu.
  // Zato se dio naslova koji je velicina izbacuje dok izbora nema.
  function stickyVariantLabel(variant) {
    var parts = String(variant.title || '').split(' / ');
    if (needsSize() && variant.size) {
      var pos = parseInt(data.sizePosition, 10);
      if (pos > 0 && parts.length >= pos && parts[pos - 1] === variant.size) {
        parts.splice(pos - 1, 1);
      } else {
        parts = parts.filter(function (p) { return p !== variant.size; });
      }
    }
    // Proizvod bez boje i druge opcije: naslov je bio samo velicina, pa
    // ostaje prazno — bolje nista nego tudji izbor.
    if (parts.length === 1 && parts[0] === 'Default Title') return '';
    return parts.join(' · ');
  }

  function askForSize() {
    var box = root.querySelector('[data-pdp-size-chips]');
    if (!box) return;
    var wrap = box.closest('.n-pdp__sizes') || box;
    wrap.classList.add('is-asking');
    setTimeout(function () { wrap.classList.remove('is-asking'); }, 1600);
    try {
      var y = wrap.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: y, behavior: 'smooth' });
    } catch (err) { /* okruzenja bez scrollTo ne smiju oboriti dodavanje */ }
    var first = box.querySelector('[data-pdp-size]');
    if (first && first.focus) first.focus({ preventScroll: true });
  }

  function addToCart(button, goCheckout) {
    var items;
    if (mixActive()) {
      if (mixMissing()) { askForMix(); return; }
      items = mixItems();
    } else {
      if (needsSize()) { askForSize(); return; }
      var variant = currentVariant();
      if (!variant || !variant.available) return;
      items = [{ id: variant.id, quantity: state.tierQty }];
    }
    if (!window.NattaCart) return;
    if (adding) return; // dvoklik ne smije dodati proizvod dva puta
    adding = true;
    var cta = els.cta;
    var busyBtn = button || cta;
    setBusy(busyBtn, true, goCheckout);
    // „Kupi odmah" ne otvara korpu — kupac ide pravo na naplatu.
    window.NattaCart.add(items, goCheckout ? { open: false } : undefined)
      .then(function () {
        if (goCheckout) {
          window.location.href = '/checkout';
          return;
        }
        setBusy(busyBtn, false);
        // potvrda se prikazuje tek kad je dodavanje stvarno uspjelo
        if (!cta) return;
        var label = els.ctaLabel;
        cta.classList.add('n-btn--added');
        if (label) {
          label.dataset.prev = label.textContent;
          label.textContent = '✓ Dodato u korpu';
        }
        clearTimeout(flashTimer);
        flashTimer = setTimeout(function () {
          cta.classList.remove('n-btn--added');
          update();
        }, 1800);
      })
      .catch(function () {
        // dodavanje palo — bez lazne potvrde, vrati CTA u normalno stanje
        setBusy(busyBtn, false);
        update();
      })
      .then(function () { adding = false; });
  }

  /* Dugme odmah pokazuje da se nesto desava (vlasnik, 9. 10. 2026: „drawer
     zakasni nekoliko sekundi, a na dugmetu se ne vidi nista"). Kruzic +
     „Dodajem…"; glavni CTA mijenja samo svoj label, da cijena ne nestane
     iz DOM-a. Kod „Kupi odmah" stanje ostaje do odlaska na naplatu. */
  function setBusy(btn, on, checkout) {
    if (!btn) return;
    btn.classList.toggle('is-busy', on);
    if (on) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
    var target = btn === cta0 && els.ctaLabel ? els.ctaLabel : btn;
    if (on) {
      target.setAttribute('data-busy-prev', target.textContent);
      target.textContent = checkout ? 'Otvaram naplatu…' : 'Dodajem…';
    } else if (target.hasAttribute('data-busy-prev')) {
      target.textContent = target.getAttribute('data-busy-prev');
      target.removeAttribute('data-busy-prev');
    }
  }
  var cta0 = els.cta;

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart();
    });
  }
  if (els.buyNow) {
    els.buyNow.addEventListener('click', function () { addToCart(els.buyNow, true); });
  }
  root.querySelectorAll('[data-pdp-sticky-add]').forEach(function (b) {
    b.addEventListener('click', function () { addToCart(b); });
  });

  /* ---------- sticky bars ---------- */
  var stickyDesktop = root.querySelector('[data-pdp-sticky-desktop]');
  if (stickyDesktop) {
    window.addEventListener(
      'scroll',
      function () {
        stickyDesktop.classList.toggle('is-visible', window.scrollY > 720);
      },
      { passive: true }
    );
  }

  /* ---------- fit-finder ---------- */
  /* ---------- init ---------- */
  renderGallery(true);
  update();
})();

/* ===================== natta-collection.js ===================== */
/* ============================================================
   NATTA Form — kolekcija: chip filteri (TIP/ZONA/NIVO),
   AND logika, live count, empty state.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-natta-collection]');
  if (!root || root.dataset.collInit) return;
  root.dataset.collInit = '1';

  var state = { tip: 'all', zona: 'all', nivo: 'all' };
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-coll-item]'));
  var countEl = root.querySelector('[data-coll-count]');
  var emptyEl = root.querySelector('[data-coll-empty]');
  var gridEl = root.querySelector('[data-coll-grid]');

  function plural(n) {
    // bosanski: 1 proizvod, 2-4 proizvoda, 5+ proizvoda
    var mod10 = n % 10;
    var mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return n + ' proizvod';
    return n + ' proizvoda';
  }

  function filterActive() {
    return state.tip !== 'all' || state.zona !== 'all' || state.nivo !== 'all';
  }

  function apply() {
    var visible = 0;
    items.forEach(function (item) {
      var tip = item.dataset.tip || '';
      var zona = item.dataset.zona || '';
      var nivo = item.dataset.nivo || '';
      var show =
        (state.tip === 'all' || tip === state.tip) &&
        (state.zona === 'all' || zona.indexOf('|' + state.zona + '|') >= 0) &&
        (state.nivo === 'all' || nivo === state.nivo);
      item.hidden = !show;
      if (show) visible++;
    });
    // Sa paginacijom `visible` je broj na TRENUTNOJ stranici, a red iznad
    // grida nosi ukupan broj u kolekciji. Prepisujemo ga samo kad je
    // filter stvarno aktivan — inace bi kolekcija od 117 pisala „48".
    if (countEl && filterActive()) countEl.textContent = plural(visible);
    else if (countEl && countEl.dataset.total) countEl.textContent = countEl.dataset.total;
    // Prazna kolekcija ima svoj empty state UNUTAR grida (poruka + link na
    // cijelu ponudu). Kad nema nijedne stavke, sakriti grid znaci sakriti i
    // tu poruku, a umjesto nje ostaje „Nema proizvoda za ovu kombinaciju
    // filtera" sa dugmetom koje nema sta ponistiti.
    if (items.length === 0) return;
    if (emptyEl) emptyEl.hidden = visible > 0;
    if (gridEl) gridEl.hidden = visible === 0;
  }

  // Filteri se mogu otvoriti i preko adrese: /collections/x?zona=grudi
  // Time oglas moze voditi pravo na „Grudi" umjesto na cijelu kolekciju, a
  // kupac moze podijeliti ili sacuvati filtriran pogled. Bez ovoga je
  // stanje zivjelo samo u memoriji stranice.
  var GROUPS = ['tip', 'zona', 'nivo'];

  function syncChips() {
    GROUPS.forEach(function (g) {
      root.querySelectorAll('[data-filter="' + g + '"]').forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.value === state[g]);
      });
    });
  }

  function readUrl() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (err) { return; }
    GROUPS.forEach(function (g) {
      var v = params.get(g);
      if (!v) return;
      v = v.toLowerCase();
      // Prihvatamo samo vrijednost koja stvarno postoji kao cip — inace bi
      // `?zona=bilosta` dala praznu kolekciju bez ijednog aktivnog cipa.
      var chip = root.querySelector('[data-filter="' + g + '"][data-value="' + v.replace(/"/g, '') + '"]');
      if (chip) state[g] = v;
    });
  }

  function writeUrl() {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      GROUPS.forEach(function (g) {
        if (state[g] === 'all') url.searchParams.delete(g);
        else url.searchParams.set(g, state[g]);
      });
      window.history.replaceState({}, '', url.toString());
    } catch (err) { /* stariji preglednici — filter i dalje radi */ }
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-filter]');
    if (chip) {
      var group = chip.dataset.filter;
      state[group] = chip.dataset.value;
      root.querySelectorAll('[data-filter="' + group + '"]').forEach(function (c) {
        c.classList.toggle('is-active', c === chip);
      });
      apply();
      writeUrl();
      return;
    }
    if (e.target.closest('[data-coll-reset]')) {
      state = { tip: 'all', zona: 'all', nivo: 'all' };
      root.querySelectorAll('[data-filter]').forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.value === 'all');
      });
      apply();
      writeUrl();
    }
  });

  // Sortiranje: <form> radi i bez JS-a, ovo samo uklanja korak „Primijeni".
  var sortForm = root.querySelector('[data-coll-sort]');
  if (sortForm) {
    var sortSelect = sortForm.querySelector('select[name="sort_by"]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () { sortForm.submit(); });
    }
  }

  readUrl();
  syncChips();
  apply();
})();

/* ===================== natta-pdp-final.js (FINAL PDP dodaci) ===================== */
(function () {
  'use strict';

  // Otvara SizeMind prozor odmah na sekciji „Tabela velicina". Vraca false
  // (pa se otvara stara tabela) ako je postavka „stranica", ako SizeMind za
  // ovaj proizvod nije potvrdio tabelu ili ako njegov widget nije na stranici.
  function openSizeMindChart() {
    var cfg = (window.NattaSettings && window.NattaSettings.sizeGuide) || 'sizemind';
    if (cfg !== 'sizemind') return false;
    var block = document.querySelector('[id$="__sizemind"]');
    if (!block || block.getAttribute('data-sm-ok') !== '1' || block.getAttribute('data-sm-chart') !== '1') return false;
    var card = document.getElementById('sizemind-cta-card');
    if (!card) return false;
    card.click();
    var tries = 0;
    var clicked = false;
    (function toChart() {
      var wrap = document.getElementById('sizemind-chart-table-wrap');
      var toggles = document.querySelectorAll('.sm-accordion-toggle');
      var tog = null;
      for (var i = 0; i < toggles.length; i++) {
        if (/Tabela/i.test(toggles[i].textContent || '')) { tog = toggles[i]; break; }
      }
      // SizeMind sekcija zna drzati aria-expanded="true" dok joj je sadrzaj
      // sakriven, pa se gleda stvarna vidljivost tijela sekcije. Klik samo
      // jednom — drugi bi je opet zatvorio.
      var body = tog && tog.nextElementSibling;
      if (tog && !clicked && body && window.getComputedStyle(body).display === 'none') {
        tog.click();
        clicked = true;
      }
      if (wrap && wrap.offsetParent !== null) {
        try { wrap.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (err) { wrap.scrollIntoView(); }
        return;
      }
      if (++tries < 20) setTimeout(toChart, 120);
    })();
    return true;
  }
  window.NattaOpenSizeMindChart = openSizeMindChart;
  // size-table modal + final CTA smooth-scroll (delegirano, radi i na FINAL template-u)
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-sizemodal-open]');
    if (openBtn) {
      // Vodic za velicine -> SizeMind tabela (postavka natta_size_guide_source).
      // Stara tabela (stranica iz metafielda) ostaje u temi kao rezerva i
      // otvara se kad SizeMind za proizvod nema tabelu ili je postavka
      // vracena na „stranica".
      if (openSizeMindChart()) return;
      var sec = openBtn.closest('section');
      // Link iz sekcije recenzija (natta-reviews-pdp) nije u istoj sekciji
      // kao modal — tada se otvara jedini modal velicina na stranici.
      var m = (sec && sec.querySelector('[data-sizemodal]')) || document.querySelector('[data-sizemodal]');
      if (m) {
        m.classList.add('is-open');
        m.setAttribute('aria-hidden', 'false');
        document.body.classList.add('n-no-scroll');
      }
      return;
    }
    if (e.target.closest('[data-sizemodal-close]')) {
      var mm = e.target.closest('[data-sizemodal]') || document.querySelector('[data-sizemodal].is-open');
      if (mm) {
        mm.classList.remove('is-open');
        mm.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('n-no-scroll');
      }
      return;
    }
    var fc = e.target.closest('[data-final-cta]');
    if (fc) {
      var target = document.querySelector('[data-pdp-cta]') || document.querySelector('[data-pdp-buybox]') || document.querySelector('[data-natta-pdp]');
      if (target) {
        var y = target.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  });
  // Escape zatvara SVAKI otvoreni modal, ne samo modal velicina. UGC modal
  // i lightbox recenzija su se ranije mogli zatvoriti jedino misem — na
  // tastaturi je fokus ostajao zarobljen iza overlaya.
  var ESC_MODALS = '[data-sizemodal].is-open, [data-ugc-modal].is-open, [data-reviews-lightbox].is-open';
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var menu = document.querySelector('[data-natta-menu-drawer].is-open');
    if (menu) {
      var menuCloseEl = menu.querySelector('[data-natta-menu-close]');
      if (menuCloseEl) { menuCloseEl.click(); return; }
    }
    // Selektor je bio `[data-natta-cart]`, a u markupu (cart-drawer.liquid)
    // i u svakom drugom mjestu u ovom fajlu stoji `[data-natta-cart-drawer]`.
    // Ta grana zato nikad nije nasla ladicu — Escape je zatvarao modale, a
    // korpu nikad, iako komentar iznad tvrdi suprotno.
    var drawer = document.querySelector('[data-natta-cart-drawer].is-open');
    if (drawer) {
      var closeEl = drawer.querySelector('[data-natta-cart-close]');
      if (closeEl) { closeEl.click(); return; }
    }
    var open = document.querySelectorAll(ESC_MODALS);
    if (!open.length) return;
    Array.prototype.forEach.call(open, function (m) {
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
      var v = m.querySelector('[data-ugc-video]');
      if (v) { try { v.pause(); } catch (err) {} v.removeAttribute('src'); v.hidden = true; }
    });
    document.body.classList.remove('n-no-scroll');
  });
})();

/* ===================== recenzije na PDP-u (sections/natta-reviews-pdp.liquid) =====================
   Judge.me widget ostaje netaknut: cipovi i dugmad ove sekcije samo
   klikaju NJEGOVE elemente. Tako filter po zvjezdicama, paginacija i
   pisanje recenzije ostaju Judge.me-ovi i rade zajedno — vlastiti filter
   bi filtrirao samo pet recenzija koje su trenutno na stranici.
   Judge.me atributi (data-rating, data-frequency) se citaju preko
   getAttribute, ne kroz [data-...] selektore: tests/validate/hooks.py
   trazi svaki takav selektor u nasem markupu, a ovi su Judge.me-ovi. */
(function () {
  'use strict';
  var root = document.querySelector('[data-natta-rv]');
  if (!root) return;

  var chipsEl = root.querySelector('[data-rv-chips]');
  var histBtn = root.querySelector('[data-rv-hist]');
  var writeBtn = root.querySelector('[data-rv-write]');
  var sizeBox = root.querySelector('[data-rv-size]');
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  // Link „Vodic za velicine" ima smisla samo ako modal postoji na stranici.
  if (sizeBox && document.querySelector('[data-sizemodal]')) sizeBox.hidden = false;

  var STAR = '<svg class="n-rv__chip-star" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4L2.8 9.5l6.4-.8z"/></svg>';

  // 1 zvjezdica, 2–4 zvjezdice, 5 zvjezdica
  var word = function (n) { return n >= 2 && n <= 4 ? 'zvjezdice' : 'zvjezdica'; };

  var rows = function () {
    return root.querySelectorAll('.jdgm-histogram__row:not(.jdgm-histogram__clear-filter)');
  };

  var sync = function () {
    if (!chipsEl) return;
    // „Pogledaj sve" je i sam red histograma (data-rating="null") i Judge.me
    // ga oznaci kao izabranog — to znaci „bez filtera", ne ocjenu.
    var sel = root.querySelector('.jdgm-histogram__row--selected:not(.jdgm-histogram__clear-filter)');
    var cur = sel ? sel.getAttribute('data-rating') || '' : '';
    each(chipsEl.querySelectorAll('.n-rv__chip'), function (c) {
      c.setAttribute('aria-pressed', String((c.getAttribute('data-rv-rating') || '') === cur));
    });
  };

  var built = false;
  var build = function () {
    if (built) return;
    if (!root.querySelector('.jdgm-rev-widg')) return;
    built = true;
    root.classList.add('is-ready');

    var rs = rows();
    if (histBtn && rs.length) histBtn.hidden = false;
    if (writeBtn && root.querySelector('.jdgm-write-rev-link')) writeBtn.hidden = false;

    // Brojke su Judge.me-ove (data-frequency), cip se pravi samo za ocjenu
    // koja stvarno ima recenzija. Sa jednom jedinom ocjenom („Sve (22)" i
    // „5 zvjezdica (22)") cipovi nemaju sta filtrirati, pa ih nema.
    var total = 0;
    var used = [];
    each(rs, function (r) {
      var f = parseInt(r.getAttribute('data-frequency'), 10) || 0;
      var n = parseInt(r.getAttribute('data-rating'), 10);
      total += f;
      if (f > 0 && n >= 1 && n <= 5) used.push({ n: n, f: f });
    });
    if (chipsEl && used.length > 1) {
      var html = '<button type="button" class="n-rv__chip" aria-pressed="true" data-rv-rating="">Sve (' + total + ')</button>';
      used.forEach(function (u) {
        html += '<button type="button" class="n-rv__chip" aria-pressed="false" data-rv-rating="' + u.n + '">' +
          u.n + ' <span class="n-rv__chip-word">' + word(u.n) + '</span>' + STAR + ' (' + u.f + ')</button>';
      });
      chipsEl.innerHTML = html;
      chipsEl.hidden = false;
    }
    sync();
  };

  if (chipsEl) {
    chipsEl.addEventListener('click', function (e) {
      var chip = e.target.closest('.n-rv__chip');
      if (!chip) return;
      var n = chip.getAttribute('data-rv-rating') || '';
      var target = null;
      if (!n) {
        target = root.querySelector('.jdgm-histogram__clear-filter');
      } else {
        each(rows(), function (r) { if (!target && r.getAttribute('data-rating') === n) target = r; });
      }
      // Judge.me slusa klik na red histograma (delegirano) — isti filter
      // kao kad kupac klikne traku, sa njegovom paginacijom.
      if (target) target.click();
      sync();
      // Judge.me poslije filtera ponovo iscrta listu i stranica skoci (na
      // desktopu ~500px), pa rezultati ostanu van ekrana (usability,
      // 9. 10. 2026). Kad se lista smiri, cipovi se vrate u vidno polje.
      setTimeout(function () {
        var top = chipsEl.getBoundingClientRect().top;
        if (top < 70 || top > window.innerHeight * 0.6) {
          window.scrollTo({ top: Math.max(0, window.scrollY + top - 90), behavior: 'smooth' });
        }
      }, 450);
    });
  }

  if (histBtn) {
    histBtn.addEventListener('click', function () {
      var open = root.classList.toggle('is-hist-open');
      histBtn.setAttribute('aria-expanded', String(open));
    });
  }

  if (writeBtn) {
    writeBtn.addEventListener('click', function () {
      var link = root.querySelector('.jdgm-write-rev-link');
      if (!link) return;
      // Judge.me modul za pisanje ucitava tek na PRVI klik svog linka: taj
      // klik samo doda modal (skriven) i otkrije link, tek drugi ga otvori.
      // Kupac ne smije kliknuti dvaput, pa drugi klik radimo mi — samo ako
      // modal poslije ucitavanja jos nije otvoren. setTimeout, ne rAF: rAF
      // ne radi u skrivenom tabu/pregledu.
      var wasLoaded = !!document.querySelector('.jdgm-write-review-modal');
      link.click();
      if (wasLoaded) return;
      var tries = 0;
      var wait = function () {
        var m = document.querySelector('.jdgm-write-review-modal');
        if (m && m.offsetWidth > 0) return;
        if (m && link.style.display !== 'none') { link.click(); return; }
        // Stari tok bez modala: forma se otvori u widgetu — dovedi je u vidno polje.
        var fw = root.querySelector('.jdgm-form-wrapper');
        if (fw && fw.offsetHeight > 0) { fw.scrollIntoView({ block: 'start', behavior: 'smooth' }); return; }
        tries += 1;
        if (tries < 40) setTimeout(wait, 150);
      };
      setTimeout(wait, 150);
    });
  }

  build();
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      build();
      sync();
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
})();

/* ===================== mega meni =====================
   Preseljen u assets/natta-header.js (redizajn headera 10/2026). Novi
   meni ima zasebno dugme sa strelicom za tastaturu i dodir, a stari kod
   je otvarao panel na focusin linka — da ostane ovdje, oba bi se vezala
   na iste [data-mega-item] elemente i panel bi se otvarao dvaput. */


/* ── SizeMind: prikazi samo gdje tabela zaista postoji ────────────────────
   U SizeMind adminu su dodijeljene tri tabele (dva grudnjaka po ID-u i
   kupaci po tagu). Njihov server to postuje — za sve ostalo vraca
   {"success":false,"error":"No size chart found for this product"}. Ali
   widget svoju karticu „Pronadite savrsen kroj" iscrta prije nego dobije
   odgovor i ne makne je kad odgovor stigne. Zato se na svim proizvodima
   nudilo mjerenje koje nema sta preporuciti.

   Rjesenje: blok stoji sakriven (CSS), mi pitamo isti endpoint i
   otkrivamo ga samo na `success: true`. Ako upit padne, otkrivamo ga
   svejedno — bolje visak nego da sakrijemo tabelu koja postoji.        */
(function () {
  var pdp = document.querySelector('[data-natta-pdp]');
  if (!pdp) return;

  var block = document.querySelector('[id$="__sizemind"]');
  if (!block) return;

  var show = function () { block.setAttribute('data-sm-ok', '1'); };
  // Tabela je stvarno potvrdjena (success: true) — tek tada „Vodic za
  // velicine" smije otvarati SizeMind umjesto stare stranice.
  var confirmed = function () {
    show();
    block.setAttribute('data-sm-chart', '1');
    var cfg = (window.NattaSettings && window.NattaSettings.sizeGuide) || 'sizemind';
    if (cfg !== 'sizemind') return;
    document.querySelectorAll('[data-size-guide-sm-only]').forEach(function (b) { b.hidden = false; });
    document.querySelectorAll('[data-rv-size]').forEach(function (b) { b.hidden = false; });
  };

  var shop = pdp.getAttribute('data-sm-shop');
  var id = pdp.getAttribute('data-sm-id');
  if (!shop || !id) { show(); return; }

  var url = '/apps/sizemind/size-chart'
    + '?shop=' + encodeURIComponent(shop)
    + '&productId=' + encodeURIComponent(id)
    + '&productType=' + encodeURIComponent(pdp.getAttribute('data-sm-type') || '')
    + '&tags=' + encodeURIComponent(pdp.getAttribute('data-sm-tags') || '');

  fetch(url)
    .then(function (r) { return r.json(); })
    .then(function (data) { if (data && data.success) confirmed(); })
    .catch(show);
})();

/* ===================== natta-reels.js ===================== */
/* Video price (sections/natta-video-reels.liquid): video se pusta bez
   zvuka samo dok je na ekranu, a van ekrana se pauzira — sest videa koji
   se vrte u pozadini bi trosili bateriju i mobilne podatke. Dodir na
   dugme zvuka ukljucuje zvuk tom videu i gasi ga svim ostalima. */
(function () {
  'use strict';
  var secs = document.querySelectorAll('[data-reels]');
  if (!secs.length) return;

  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay blokiran — ostaje poster */ });
  }

  var videos = [];
  secs.forEach(function (sec) {
    if (sec.dataset.reelsInit) return;
    sec.dataset.reelsInit = '1';
    sec.querySelectorAll('[data-reel]').forEach(function (v) { videos.push(v); });

    sec.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-reel-sound]');
      var fig = e.target.closest('.n-reel');
      if (!fig) return;
      var v = fig.querySelector('[data-reel]');
      if (!v) return;
      var turnOn = v.muted;
      videos.forEach(function (o) {
        o.muted = true;
        var f = o.closest('.n-reel');
        if (f) f.classList.remove('is-sound');
      });
      if (turnOn) {
        v.muted = false;
        fig.classList.add('is-sound');
        play(v);
      }
      if (btn) btn.setAttribute('aria-label', turnOn ? 'Isključi zvuk' : 'Uključi zvuk');
    });
  });

  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) {
        if (v.preload === 'none') v.preload = 'auto';
        play(v);
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: 0.5 });
  videos.forEach(function (v) { io.observe(v); });
})();

/* ===================== nedavno pogledano ===================== */
/* Vlasnik, 9. 10. 2026. Svaki otvoreni proizvod ide na pocetak liste u
   localStorage (`natta_rv`, samo handleovi, najvise 12). Kartice se ne
   cuvaju u pregledniku: dovlace se svjeze kroz sekciju natta-rv-card
   (/products/<handle>?section_id=natta-rv-card), pa cijena, rasprodato i
   brzo dodavanje uvijek odgovaraju stanju u trgovini.
   - PDP: sekcija [data-natta-recent], bez proizvoda koji se upravo gleda.
   - Prazna korpa: [data-recent-cart], puni se tek kad se korpa otvori.
   Proizvod koji vise ne postoji brise se iz liste; greska mreze ne. */
(function () {
  'use strict';
  var KEY = 'natta_rv';
  var MAX = 12;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};

  function read() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function forget(handle) {
    write(read().filter(function (h) { return h !== handle; }));
  }

  // Handle dolazi iz Liquida (sekcija na PDP-u), ne iz URL-a: /products/<x>
  // sa pogresnim handleom vraca 404 stranicu, a ona se ne smije upisati.
  var ownEl = document.querySelector('[data-recent-current]');
  var current = ownEl ? (ownEl.getAttribute('data-recent-current') || '').toLowerCase() : '';
  // Lista se cita PRIJE upisa trenutnog proizvoda; on se ionako izostavlja.
  var seen = read();
  if (current) write([current].concat(seen.filter(function (h) { return h !== current; })));

  function fetchCard(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=natta-rv-card')
      .then(function (r) {
        if (r.status === 404) return null;
        if (!r.ok) throw new Error('rv ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html || '';
        var card = tmp.querySelector('.n-card');
        // Za obrisan ili sakriven proizvod Shopify vraca 200 i praznu
        // sekciju (product je nil), a ne 404.
        if (!card) { forget(handle); return ''; }
        return card.outerHTML;
      })
      .catch(function () { delete cache[handle]; return ''; });
    return cache[handle];
  }

  function fill(box, handles, limit, eager) {
    var grid = box.querySelector('[data-recent-grid]');
    if (!grid || box.getAttribute('data-recent-busy') === '1') return;
    if (!handles.length) { box.hidden = true; return; }
    box.setAttribute('data-recent-busy', '1');
    // Par rezervnih, jer neki handle moze vratiti 404.
    Promise.all(handles.slice(0, limit + 2).map(fetchCard)).then(function (cards) {
      box.removeAttribute('data-recent-busy');
      var html = cards.filter(Boolean).slice(0, limit).join('');
      if (!html) { box.hidden = true; return; }
      grid.innerHTML = html;
      if (eager) {
        grid.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.setAttribute('loading', 'eager'); });
      }
      box.hidden = false;
      box.setAttribute('data-recent-done', '1');
    });
  }

  /* ---------- PDP ---------- */
  document.querySelectorAll('[data-natta-recent]').forEach(function (sec) {
    var own = (sec.getAttribute('data-recent-current') || '').toLowerCase();
    var limit = parseInt(sec.getAttribute('data-recent-limit'), 10) || 4;
    var list = seen.filter(function (h) { return h !== own; });
    if (!list.length) return;
    // Sekcija je na dnu stranice: krece poslije glavne slike i galerije.
    function start() { setTimeout(function () { fill(sec, list, limit, true); }, 400); }
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  });

  /* ---------- prazna korpa ---------- */
  function fillCart() {
    var box = document.querySelector('[data-natta-cart-drawer] [data-recent-cart]');
    if (!box || box.getAttribute('data-recent-done') === '1') return;
    fill(box, read(), 4, true);
  }
  var drawer = document.querySelector('[data-natta-cart-drawer]');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (drawer.getAttribute('aria-hidden') === 'false' || drawer.classList.contains('is-open')) fillCart();
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
  }
  if (window.NattaEvents) {
    // Korpa se re-renderuje poslije svake izmjene; kad zadnji komad izleti,
    // dolazi novi prazan blok koji treba napuniti.
    window.NattaEvents.subscribe('dom:updated', function () {
      if (drawer && drawer.classList.contains('is-open')) fillCart();
    });
  }
})();

/* =====================================================================
   KORPA — dodatak uz narudžbu (snippets/natta-cart-addon.liquid)
   Izbor veličine/boje mijenja varijantu koju dugme dodaje. Samo dodavanje
   ide kroz postojeći [data-cart-add-variant] handler korpe.
   Dugme se pali tek kad su izabrane SVE opcije: ranije je izbor samo
   veličine uzimao prvu boju po redu, koju kupac nije birao (pregled,
   22. 10. 2026) — kod pouzeća to je odbijen paket.
   ===================================================================== */
(function () {
  if (window.__nattaCartAddon) return;
  window.__nattaCartAddon = true;

  function fmt(c) {
    return window.NattaMoney ? window.NattaMoney.format(c) : (c / 100).toFixed(2).replace('.', ',') + ' KM';
  }

  /* Jednokratna ponuda: poslije „Ne, hvala" ili dodavanja se na tom
     uređaju više ne prikazuje. Bez ovoga bi natpis „jednokratna" bio
     netačan — blok bi se vraćao uz svaku sljedeću narudžbu. */
  var KEY = 'natta_addon_done_';
  function done(id) { try { return localStorage.getItem(KEY + id) === '1'; } catch (err) { return false; } }
  function markDone(id) { try { localStorage.setItem(KEY + id, '1'); } catch (err) {} }
  function hideDone(root) {
    (root || document).querySelectorAll('[data-cart-addon]').forEach(function (b) {
      if (done(b.getAttribute('data-addon-id'))) b.hidden = true;
    });
  }
  hideDone();
  if (window.NattaEvents) window.NattaEvents.subscribe('dom:updated', function (el) { hideDone(el); });

  document.addEventListener('click', function (e) {
    var no = e.target.closest('[data-cart-addon] [data-addon-dismiss]');
    var yes = e.target.closest('[data-cart-addon] [data-addon-taken][data-cart-add-variant]');
    var hit = no || yes;
    if (!hit) return;
    var b = hit.closest('[data-cart-addon]');
    if (b.getAttribute('data-off') !== '0') return; // samo jednokratna ponuda (bez popusta)
    markDone(b.getAttribute('data-addon-id'));
    if (no) b.hidden = true;
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-addon] input[data-addon-pos]');
    if (!input) return;
    var box = input.closest('[data-cart-addon]');
    if (!box.__auto) box.setAttribute('data-touched', '1');
    var data;
    try { data = JSON.parse(box.querySelector('[data-addon-variants]').textContent); } catch (err) { return; }

    var sizePos = box.getAttribute('data-size-pos');
    var colorPos = box.getAttribute('data-color-pos');
    var sel = function (pos) { return box.querySelector('input[data-addon-pos="' + pos + '"]:checked'); };

    // promjena veličine: ugasi boje kojih u toj veličini nema
    if (sizePos !== '0' && colorPos !== '0' && input.getAttribute('data-addon-pos') === sizePos) {
      box.querySelectorAll('input[data-addon-pos="' + colorPos + '"]').forEach(function (c) {
        var has = data.some(function (v) { return v.a && v.o[sizePos - 1] === input.value && v.o[colorPos - 1] === c.value; });
        c.disabled = !has;
        if (!has && c.checked) c.checked = false;
      });
    }

    var picked = {};
    var positions = [];
    if (sizePos !== '0') positions.push(sizePos);
    if (colorPos !== '0') positions.push(colorPos);
    positions.forEach(function (pos) { var i = sel(pos); if (i) picked[pos] = i.value; });
    var missing = positions.filter(function (pos) { return !picked[pos]; });

    var nameEl = box.querySelector('[data-addon-color-name]');
    if (nameEl) nameEl.textContent = picked[colorPos] || '';

    var match = null;
    if (!missing.length) {
      for (var k = 0; k < data.length; k++) {
        var v = data[k];
        if (positions.every(function (pos) { return v.o[pos - 1] === picked[pos]; })) { match = v; break; }
      }
    }

    // slika prati boju čim je izabrana
    var img = box.querySelector('[data-addon-img]');
    var forImg = match || (picked[colorPos] && data.filter(function (v) { return v.o[colorPos - 1] === picked[colorPos]; })[0]);
    if (img && forImg && forImg.img) img.src = forImg.img;

    var btn = box.querySelector('[data-addon-add]');
    var off = parseInt(box.getAttribute('data-off'), 10) || 0;
    if (match && match.a) {
      var now = Math.max(0, match.p - off);
      btn.setAttribute('data-cart-add-variant', match.id);
      btn.disabled = false;
      btn.textContent = '+ Dodajte za ' + fmt(now);
      var nw = box.querySelector('[data-addon-new]');
      var od = box.querySelector('[data-addon-old]');
      if (nw) nw.textContent = fmt(now);
      if (od) od.textContent = fmt(match.p);
    } else {
      btn.removeAttribute('data-cart-add-variant');
      btn.disabled = true;
      if (missing.indexOf(sizePos) !== -1) btn.textContent = 'Izaberite veličinu';
      else if (missing.length) btn.textContent = 'Izaberite boju';
      else btn.textContent = 'Ova kombinacija nije dostupna';
    }
  });

  /* ---------- izbor veličine po MJERAMA (SizeMind) ----------
     Slova lažu između modela: Lena S ima struk 71–76 cm, a to je kod
     gaćica WSHb62213 veličina M (72–75). Zato se uzima struk izabrane
     veličine bodija iz njegove SizeMind tabele i bira veličina dodatka u
     koju pada; između dvije -> veća (oblikujuće rublje ne smije biti tijesno).
     Bez tabele ostaje izbor po slovima iz Liquida. Ako kupac već sam
     izabere, ništa se ne mijenja. */
  var TOL = 3; // cm — dalje od ovoga nijedna veličina ne odgovara -> blok se sakrije
  var charts = {};
  function normSize(x) { return String(x || '').toUpperCase().replace(/\s+/g, '').replace(/(^|\/)2XL/g, '$1XXL'); }
  function chart(shop, id, type, tags) {
    if (typeof fetch !== 'function') return Promise.resolve(null);
    if (!charts[id]) {
      var url = '/apps/sizemind/size-chart?shop=' + encodeURIComponent(shop) + '&productId=' + encodeURIComponent(id)
        + '&productType=' + encodeURIComponent(type || '') + '&tags=' + encodeURIComponent(tags || '');
      charts[id] = fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (d) { var sc = d && d.success !== false && (d.sizeChart || d); return sc && sc.entries && sc.entries.length ? sc.entries : null; })
        .catch(function () { return null; });
    }
    return charts[id];
  }
  function mid(e) {
    if (e.minWaist != null && e.maxWaist != null) return { v: (e.minWaist + e.maxWaist) / 2, k: 'Waist' };
    if (e.minHips != null && e.maxHips != null) return { v: (e.minHips + e.maxHips) / 2, k: 'Hips' };
    return null;
  }
  function bySize(box) {
    if (box.getAttribute('data-sm-done')) return;
    box.setAttribute('data-sm-done', '1');
    var shop = box.getAttribute('data-sm-shop');
    var trigSize = box.getAttribute('data-trig-size');
    var sizePos = box.getAttribute('data-size-pos');
    if (!shop || !trigSize || sizePos === '0') return;
    Promise.all([
      chart(shop, box.getAttribute('data-trig-id'), box.getAttribute('data-trig-type'), box.getAttribute('data-trig-tags')),
      chart(shop, box.getAttribute('data-addon-id'), box.getAttribute('data-sm-addon-type'), box.getAttribute('data-sm-addon-tags')),
    ]).then(function (res) {
      var body = res[0], add = res[1];
      if (!body || !add || box.getAttribute('data-touched') || !box.isConnected) return;
      var be = body.filter(function (e) { return normSize(e.sizeName) === normSize(trigSize); })[0];
      var m = be && mid(be);
      if (!m) return;
      var data;
      try { data = JSON.parse(box.querySelector('[data-addon-variants]').textContent); } catch (err) { return; }
      var best = null;
      add.forEach(function (e) {
        var lo = e['min' + m.k], hi = e['max' + m.k];
        if (lo == null || hi == null) return;
        var input = Array.prototype.filter.call(box.querySelectorAll('input[data-addon-pos="' + sizePos + '"]'), function (i) { return normSize(i.value) === normSize(e.sizeName); })[0];
        if (!input) return;
        var avail = data.some(function (v) { return v.a && v.o[sizePos - 1] === input.value; });
        if (!avail) return;
        var d = m.v < lo ? lo - m.v : (m.v > hi ? m.v - hi : 0);
        if (!best || d < best.d || (d === best.d && (e.sortOrder || 0) > (best.e.sortOrder || 0))) best = { d: d, e: e, input: input };
      });
      if (!best || best.d > TOL) { box.hidden = true; return; }
      box.querySelectorAll('.n-cart__addon-chip.is-hint').forEach(function (c) { c.classList.remove('is-hint'); });
      var colorPos = box.getAttribute('data-color-pos');
      box.__auto = true;
      best.input.checked = true;
      best.input.dispatchEvent(new Event('change', { bubbles: true }));
      // nijedna boja izabrana (slova nisu dala veličinu) -> prva dostupna u toj veličini
      if (colorPos !== '0' && !box.querySelector('input[data-addon-pos="' + colorPos + '"]:checked')) {
        var c = box.querySelector('input[data-addon-pos="' + colorPos + '"]:not(:disabled)');
        if (c) { c.checked = true; c.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      box.__auto = false;
      // Zašto baš ta veličina — činjenica o mjerama, ostaje tačna i ako
      // kupac promijeni izbor.
      var note = box.querySelector('[data-addon-size-note]');
      if (note) note.textContent = '';
      var why = box.querySelector('[data-addon-why]');
      if (why) {
        var label = m.k === 'Waist' ? 'struk' : 'bokovi';
        var range = function (e) { return e['min' + m.k] + '–' + e['max' + m.k] + ' cm'; };
        // Bez imenice („Vaš bodi"): ponuda ide uz sve proizvode, pa bi uz
        // haljinu ili gaćice rečenica bila gramatički i stvarno pogrešna.
        var txt = 'Vaša veličina ' + trigSize + ' (' + label + ' ' + range(be) + ') ';
        // Raspon bodija (M/L = 71–80) može pokriti DVIJE veličine gaćica —
        // tada to reći i dati granicu, inače bi žena sa strukom 72 uzela L.
        var bLo = be['min' + m.k], bHi = be['max' + m.k];
        var covered = add.filter(function (e) {
          var lo = e['min' + m.k], hi = e['max' + m.k];
          return lo != null && hi != null && hi > bLo && lo < bHi;
        });
        var smaller = covered.filter(function (e) { return (e.sortOrder || 0) < (best.e.sortOrder || 0); }).pop();
        if (covered.length > 1 && covered.indexOf(best.e) !== -1 && smaller) {
          txt += 'pokriva gaćice ' + smaller.sizeName + ' i ' + best.input.value + '. Izabrali smo ' + best.input.value
            + '; ako vam je ' + label + ' ispod ' + best.e['min' + m.k] + ' cm, uzmite ' + smaller.sizeName + '.';
        } else if (best.d === 0) {
          txt += 'odgovara gaćicama ' + best.input.value + ' (' + range(best.e) + ').';
        } else {
          var lower = add.filter(function (e) { return e['max' + m.k] != null && e['max' + m.k] <= m.v && e !== best.e; }).pop();
          txt += lower
            ? 'je između gaćica ' + lower.sizeName + ' i ' + best.input.value + ', pa smo izabrali veću da ne steže.'
            : 'je najbliža gaćicama ' + best.input.value + ' (' + range(best.e) + ').';
        }
        why.textContent = txt;
        why.hidden = false;
      }
    });
  }
  function scan(root) { (root || document).querySelectorAll('[data-cart-addon]:not([hidden])').forEach(bySize); }
  scan();
  if (window.NattaEvents) window.NattaEvents.subscribe('dom:updated', function (el) { scan(el); });
})();

/* =========================================================================
   Judge.me: samo JEDNA ocjena za Google (Search Console 22. 10. 2026:
   „Review has multiple aggregate ratings", 6 proizvoda, od 10. 10.).
   Naš ProductGroup (snippets/natta-jsonld-product.liquid) nosi ocjenu iz
   Judge.me metafielda i isti @id kao Judge.me-ov <script
   class="jdgm-aggregate-rating-jld">; Google spoji oba čvora i dobije dvije
   ocjene. Judge.me blok ubacuje JS-om (lijeno, uz widget), pa ga ovdje
   gasimo postavkom i uklanjamo ako se ipak pojavi. Trajno: Judge.me ->
   Settings -> SEO / rich snippets -> isključiti JSON-LD.
   ========================================================================= */
(function () {
  'use strict';
  if (!document.querySelector('[data-natta-pdp], [data-pdp-final]')) return;
  var SEL = 'script.jdgm-aggregate-rating-jld';
  if (window.jdgmSettings) window.jdgmSettings.disable_json_ld = true;
  function sweep(root) {
    var list = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    for (var i = 0; i < list.length; i++) list[i].remove();
  }
  sweep(document);
  if (!window.MutationObserver) return;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches(SEL)) n.remove();
        else sweep(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
